/**
 * InsulaCharter - Localizzazione Italiano (Default)
 * Adattato da AlguerHouse per noleggio barche
 */

const it = {
  // ============================================
  // MARKUP INCLUSIVE (richiesta/approvazione)
  // ============================================
  markupInclusive: {
    title: 'Prezzi inclusive',
    subtitle: 'Richiedi che il markup piattaforma sia incluso nel prezzo mostrato',
    rental: 'Noleggio',
    excursion: 'Escursioni',
    statusActive: 'Attivo',
    statusPending: 'In attesa di approvazione',
    statusInactive: 'Non attivo',
    request: 'Richiedi',
    requested: 'Richiesta inviata',
    requestError: 'Errore invio richiesta',
    approve: 'Approva',
    reject: 'Rifiuta',
    approved: 'Richiesta approvata',
    rejected: 'Richiesta rifiutata',
    actionError: 'Errore operazione',
    adminTitle: 'Markup inclusive',
    adminHint: 'Approva o rifiuta le richieste di prezzo inclusive per ramo.',
    vendorHint: 'Fino all’approvazione il prezzo resta additivo (markup a parte).',
  },
  // ============================================
  // METADATA & SEO
  // ============================================
  metadata: {
    siteTitle: 'InsulaCharter - Noleggio Barche in Sardegna',
    siteDescription: 'Trova la barca perfetta per la tua avventura tra le acque cristalline della Costa Smeralda e le calette della Sardegna.',
    loginTitle: 'Accedi - InsulaCharter',
    loginDescription: 'Accedi al tuo account InsulaCharter',
    registerTitle: 'Registrati - InsulaCharter',
    registerDescription: 'Crea il tuo account InsulaCharter',
  },

  // ============================================
  // COMMON / SHARED
  // ============================================
  common: {
    all: 'Tutti',
    loading: 'Caricamento...',
    error: 'Errore',
    errorPrefix: 'Errore: ',
    serverError: 'Errore del server',
    cancel: 'Annulla',
    confirm: 'Conferma',
    success: 'Operazione completata',
    save: 'Salva',
    saving: 'Salvataggio...',
    create: 'Crea',
    edit: 'Modifica',
    delete: 'Elimina',
    search: 'Cerca',
    searchNow: 'CERCA ORA',
    back: 'Indietro',
    next: 'Avanti',
    close: 'Chiudi',
    yes: 'Sì',
    no: 'No',
    free: 'Gratis',
    included: 'Incluso',
    day: 'giorno',
    days: 'giorni',
    guest: 'passeggero',
    guests: 'passeggeri',
    passengers: 'passeggeri',
    boat: 'Barca',
    meters: 'metri',
    person: 'Persona',
    persons: 'Persone',
    total: 'Totale',
    price: 'Prezzo',
    perDay: '/giorno',
    today: 'Oggi',
    uploading: 'Caricamento...',
    sending: 'Invio...',
    hour: 'ora',
    hours: 'ore',
    loginRequired: 'Accesso richiesto',
    from: 'Da',
  },

  // ============================================
  // NAVBAR
  // ============================================
  navbar: {
    logo: 'InsulaCharter',
    maintenanceMode: 'MAINTENANCE MODE - Il sito è visibile solo a te',
    maintenanceShort: 'MAINTENANCE',
    exitMaintenance: 'Esci',
    accountActive: 'Account Attivo',
    roleHost: 'Armatore',
    roleGuest: 'Ospite',
    adminPanel: 'Dashboard',
    adminSettings: 'Impostazioni',
    myTrips: 'Profilo',
    myRequests: 'Le mie richieste',
    logout: 'Esci',
    login: 'Accedi / Registrati',
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    description: 'Esperienze nautiche esclusive in Sardegna, curate con passione per garantirti il massimo comfort in mare.',
    quickLinks: 'Link Rapidi',
    exploreBoats: 'Esplora la Flotta',
    reservedArea: 'Area Riservata',
    contacts: 'Contatti',
    location: 'Sardegna, Italia',
    copyright: '© 2026 InsulaCharter.',
  },

  // ============================================
  // HOMEPAGE
  // ============================================
  home: {
    tagline: 'Sardegna • Costa Smeralda',
    welcomeTitle: 'Il Mare Ti Aspetta',
    welcomeSubtitle: 'Trova la barca perfetta per la tua avventura tra le acque cristalline della Costa Smeralda e le calette della Sardegna.',
    allPorts: 'Tutti i porti',
    passengersPlaceholder: 'Passeggeri',
    passenger1: '1 passeggero',
    passengers2: '2 passeggeri',
    passengers3: '3 passeggeri',
    passengers4: '4 passeggeri',
    passengers5: '5 passeggeri',
    passengers6Plus: '6+ passeggeri',
    ourDestinations: 'Le Nostre Destinazioni',
    categoryCoastline: 'Costa',
    categoryIslands: 'Isole',
    categoryBays: 'Calette',
    categoryOpen: 'Mare Aperto',
    boatsInSardinia: 'Barche in Sardegna',
    noBoatsTitle: 'Nessuna barca disponibile',
    noBoatsMessage: 'Prova a modificare i filtri di ricerca',
    resetSearch: 'Ripristina ricerca',
    boatFound: 'barca trovata',
    boatsFound: 'barche trovate',
    noResultsTitle: 'Nessuna barca trovata.',
    noResultsMessage: 'Prova a modificare i criteri di ricerca',
    showAllBoats: 'Mostra tutte le barche',
    verifiedFleet: 'Flotta certificata e verificata',
    insurance: 'assicurazione',
    startDate: 'Data partenza',
    endDate: 'Data ritorno',
    noLicense: 'Senza patente',
    // Hero
    premiumSelection: 'INSULA CHARTER PREMIUM SELECTION',
    heroDescription: 'Esplora le calette più segrete della Sardegna con la nostra flotta d\'eccellenza. Il lusso incontra la libertà.',
    // Benefits bar
    benefitFlexibility: 'Flessibilità Totale',
    benefitInstant: 'Noleggio Istantaneo',
    benefitCertified: 'Charter Certificati',
    // Catalog
    searchResults: 'Risultati Ricerca',
    catalogTitle: 'Catalogo Barche',
    searchResultsSubtitle: 'Abbiamo trovato {count} imbarcazioni per i tuoi criteri.',
    catalogSubtitle: 'Scopri le imbarcazioni più esclusive selezionate per te.',
    resetFilters: 'Reset Tutti i Filtri',
    noResults: 'Ops! Nessuna imbarcazione disponibile per questi criteri.',
    noResultsHint: 'Prova a modificare i filtri o a ridurre i criteri di ricerca.',
    resetFiltersBtn: 'Reset Filtri',
    loadingBoats: 'Caricamento barche...',
    loadingMap: 'Caricamento mappa...',
    // Destinations section
    exclusiveDestinations: 'Le Destinazioni più Esclusive',
    exclusiveDestinationsDesc: 'Dalla Costa Smeralda alle calette selvagge dell\'Ogliastra. Naviga verso il paradiso.',
    exploreMap: 'Esplora la Mappa',
  },

  // ============================================
  // NAVBAR (extended)
  // ============================================
  navbarExt: {
    home: 'Home',
    fleet: 'Flotta',
    excursions: 'Escursioni',
    destinations: 'Destinazioni',
    blog: 'Blog',
    vendorPanel: 'Pannello Vendor',
    vendorRole: 'Vendor',
    lightTheme: 'Tema chiaro',
    darkTheme: 'Tema scuro',
    navigation: 'Navigazione',
    administration: 'Amministrazione',
    account: 'Account',
    settings: 'Impostazioni',
    services: 'Servizi',
  },

  // ============================================
  // FOOTER (extended)
  // ============================================
  footerExt: {
    home: 'Home',
    destinations: 'Destinazioni',
    support: 'Assistenza',
    helpCenter: 'Centro Aiuto',
    termsConditions: 'Termini e Condizioni',
    cookiePrivacy: 'Cookie & Privacy',
    kaskoInsurance: 'Assicurazione Kasko',
    securePayments: 'Pagamenti Sicuri',
  },

  // ============================================
  // SEARCH SECTION
  // ============================================
  searchSection: {
    city: 'Città',
    allCities: 'Tutte',
    allCitiesLong: 'Tutte le città',
    noCities: 'Nessuna città disponibile',
    dates: 'Date',
    dateStart: 'Inizio',
    dateEnd: 'Fine',
    times: 'Orari',
    pickup: 'Ritiro',
    dropoff: 'Riconsegna',
    guests: 'Ospiti',
    passengers: 'Passeggeri',
    license: 'Patente',
    licenseAll: 'Tutte',
    licenseNo: 'No',
    search: 'Cerca',
  },

  // ============================================
  // CATALOG TOOLBAR & FILTERS
  // ============================================
  catalog: {
    // Toolbar
    filters: 'Filtri',
    searchPlaceholder: 'Cerca barca, porto, descrizione...',
    sortPriceAsc: 'Prezzo: crescente',
    sortPriceDesc: 'Prezzo: decrescente',
    sortRating: 'Valutazione',
    sortReviews: 'Più recensiti',
    sortNewest: 'Novità',
    sortName: 'Nome A-Z',
    sortDefault: 'Ordina',
    viewGrid: 'Vista griglia',
    viewList: 'Vista lista',
    viewMap: 'Vista mappa',
    boatFound: 'barca trovata',
    boatsFound: 'barche trovate',
    // Filters
    boatType: 'Tipo Barca',
    dailyPrice: 'Prezzo Giornaliero',
    priceRange: 'Range disponibile',
    passengerCapacity: 'Capacità Passeggeri',
    departureCity: 'Città di Partenza',
    allCities: 'Tutte le città',
    options: 'Opzioni',
    noLicense: 'Senza patente nautica',
    skipperAvailable: 'Skipper disponibile',
    resetFilters: 'Reset Filtri',
    showResults: 'Mostra risultati',
    // Pagination
    showing: 'Mostrando',
    of: 'di',
    results: 'risultati',
    prevPage: 'Pagina precedente',
    nextPage: 'Pagina successiva',
    pageOf: 'Pagina {current} di {total}',
  },

  // ============================================
  // BOAT CARD (extended)
  // ============================================
  boatCardExt: {
    premiere: 'Insula Première',
    licenseRequired: 'Patente Obbligatoria',
    noLicense: 'Senza Patente',
    unavailable: 'Non disponibile',
    startingFrom: 'A partire da',
    from: 'da',
    seasonalRate: 'Tariffa stagionale',
    perDay: '/giorno',
    perHalfDay: '/mezza giornata',
    perWeek: '/settimana',
    perMonth: '/mese',
    shortStaySurcharge: 'Supplemento soggiorno breve',
    length: 'Lunghezza',
    passengers: 'Passeggeri',
    cabins: 'Cabine',
    bathrooms: 'Bagni',
    engine: 'Motore',
    skipperIncluded: 'Skipper Incluso',
    skipperAvailable: 'Skipper Disponibile',
    viewAlternatives: 'Vedi Alternative',
    exploreDetails: 'Esplora Dettagli',
    alternatives: 'Alternative',
    details: 'Dettagli',
    license: 'Patente',
    noLicenseShort: 'No Patente',
    people: 'persone',
    forDays: 'per {days} giorni',
    premium: 'Premium',
  },

  // ============================================
  // DATE RANGE PICKER
  // ============================================
  datePicker: {
    title: 'Seleziona le date del noleggio',
    clearSelection: 'Cancella selezione',
    confirmDates: 'Conferma Date',
    boarding: 'Imbarco',
    disembark: 'Sbarco',
    day: 'giorno',
    days: 'giorni',
    selectBoarding: 'Seleziona la data di imbarco',
    selectDisembark: 'Seleziona la data di sbarco (clicca sulla stessa data per un noleggio di un solo giorno)',
    available: 'Disponibile',
    notAvailable: 'Non disponibile',
    halfDay: 'Mezza giornata',
    morningFree: 'Mattina libera',
    morningBooked: 'Mattina prenotata',
    afternoonFree: 'Pomeriggio libero',
    afternoonBooked: 'Pomeriggio prenotato',
    weekdayMon: 'Lun',
    weekdayTue: 'Mar',
    weekdayWed: 'Mer',
    weekdayThu: 'Gio',
    weekdayFri: 'Ven',
    weekdaySat: 'Sab',
    weekdaySun: 'Dom',
    weekdayFullMon: 'Lunedì',
    weekdayFullTue: 'Martedì',
    weekdayFullWed: 'Mercoledì',
    weekdayFullThu: 'Giovedì',
    weekdayFullFri: 'Venerdì',
    weekdayFullSat: 'Sabato',
    weekdayFullSun: 'Domenica',
    monthJan: 'Gennaio',
    monthFeb: 'Febbraio',
    monthMar: 'Marzo',
    monthApr: 'Aprile',
    monthMay: 'Maggio',
    monthJun: 'Giugno',
    monthJul: 'Luglio',
    monthAug: 'Agosto',
    monthSep: 'Settembre',
    monthOct: 'Ottobre',
    monthNov: 'Novembre',
    monthDec: 'Dicembre',
  },

  // ============================================
  // BOAT TYPES
  // ============================================
  boatTypes: {
    yacht: 'Yacht',
    sailboat: 'Vela',
    motorboat: 'Motoscafo',
    catamaran: 'Catamarano',
    dinghy: 'Gommone',
    jetski: 'Moto d\'Acqua',
  },

  // ============================================
  // BOAT CARD
  // ============================================
  boatCard: {
    exclusive: 'Premium',
    pricePerDay: 'Prezzo giornaliero',
    licenseRequired: 'Patente richiesta',
    noLicenseRequired: 'Senza patente',
    capacity: 'Capacità',
    length: 'Lunghezza',
    power: 'Potenza',
  },

  // ============================================
  // BOAT (New fields)
  // ============================================
  boat: {
    linkCopied: 'Link copiato negli appunti!',
    port: 'Porto di Partenza',
    enginePower: 'Potenza Motore',
    skipperAvailable: 'Skipper Disponibile',
    skipperIncluded: 'Skipper Incluso',
    hostessAvailable: 'Hostess Disponibile',
    noLicense: 'Senza Patente',
    licenseRequired: 'Patente Richiesta',
    amenities: 'Dotazioni di Bordo',
    extras: 'Servizi Extra',
    perStay: 'a soggiorno',
    perDay: 'al giorno',
    perPerson: 'a persona',
    perPersonPerDay: 'a persona al giorno',
    coverImage: 'Foto Copertina',
    selectCover: 'Seleziona come copertina',
    freeService: 'Gratis',
    externalServicesTitle: 'Servizi disponibili in questo porto',
    externalServicesEmpty: 'Nessun servizio esterno disponibile in questo porto.',
    externalServicesLoading: 'Caricamento servizi...',
    externalServicesPlaceholder: 'Questa imbarcazione offre servizi aggiuntivi',
    externalServicesContactUs: 'Contattaci per maggiori informazioni sui servizi disponibili.',
    availableServices: 'Servizi curati per questa barca',
    fromPrice: 'da €{price}',
    nProvidersAvailable: '{count} fornitori disponibili',
    anonymousProvider: 'Fornitore',
    externalServiceCategoryMobility: 'Noleggio / Mobilità',
    externalServiceCategoryOther: 'Servizio',
    requestQuote: 'Richiedi preventivo',
    requestQuoteTitle: 'Richiedi preventivo',
    requestQuoteDate: 'Data desiderata',
    requestQuoteGuests: 'Numero persone',
    requestQuoteNotes: 'Note (opzionale)',
    requestQuoteName: 'Il tuo nome',
    requestQuoteEmail: 'Email',
    requestQuotePhone: 'Telefono',
    requestQuoteSubmit: 'Invia richiesta',
    requestQuoteSuccess: 'Richiesta inviata. Il provider ti contatterà al più presto.',
    requestQuoteAuthHint: 'Lascia i tuoi contatti così il provider potrà risponderti',
  },

  // ============================================
  // REVIEWS (Recensioni)
  // ============================================
  reviews: {
    title: 'Gestione Recensioni',
    newReview: 'Nuova Recensione',
    editReview: 'Modifica Recensione',
    noReviews: 'Nessuna recensione',
    addFirst: 'Aggiungi la prima recensione per le tue barche',
    authorName: 'Nome Autore',
    rating: 'Valutazione',
    comment: 'Commento',
    reviewDate: 'Data Recensione',
    adminResponse: 'Risposta Admin',
    isVisible: 'Recensione visibile al pubblico',
    hidden: 'Nascosta',
    stars: 'stelle',
    star: 'stella',
    averageRating: 'Media',
    totalReviews: 'recensioni',
    selectBoat: 'Seleziona una barca',
    deleteConfirm: 'Vuoi eliminare questa recensione?',
    created: 'Recensione creata con successo',
    updated: 'Recensione aggiornata con successo',
    deleted: 'Recensione eliminata con successo',
    showReview: 'Mostra',
    hideReview: 'Nascondi',
  },

  // ============================================
  // BOAT DETAIL
  // ============================================
  boatDetail: {
    backButton: 'Esplora la Flotta',
    notFound: 'Barca non trovata.',
    loginRequired: 'Accedi per prenotare.',
    selectDates: 'Seleziona le date dalla ricerca.',
    characteristics: 'Caratteristiche',
    description: 'Descrizione',
    tagSkipper: 'Skipper Disponibile',
    tagInsured: 'Assicurazione Inclusa',
    tagSupport: 'Assistenza 24/7',
    whereIsIt: 'Porto di partenza',
    locationDescription: 'Situato nel porto di {location}, uno dei più esclusivi della Sardegna.',
    excellentPosition: 'Posizione Strategica',
    homePort: 'Porto Base',
    rate: 'Tariffa',
    rental: 'Noleggio',
    passengersLabel: 'Passeggeri',
    extrasOptional: 'Servizi Extra (Opzionali)',
    fuelPolicy: 'Carburante',
    extrasTotal: 'Servizi extra',
    bookNow: 'PRENOTA ORA',
    processing: 'IN ELABORAZIONE...',
    protectionBadge: 'Protezione InsulaCharter Garantita',
    paymentMethod: 'Metodo di Pagamento',
    selectPaymentMethod: 'Seleziona un metodo di pagamento',
    noPaymentMethods: 'Nessun metodo di pagamento salvato',
    addPaymentMethod: 'Aggiungi un metodo di pagamento',
    cashDescription: 'Paga in contanti al ritiro',
    guaranteeRequired: 'Deposito cauzionale richiesto',
    guaranteeAmount: 'Importo cauzione',
    selectGuaranteeCard: 'Seleziona la carta per la cauzione',
    cashNoCard: 'Paga in contanti (conferma admin richiesta)',
    cashNoCardDescription: 'Senza carta di garanzia, la prenotazione richiede conferma manuale',
    specifications: 'Specifiche Tecniche',
    length: 'Lunghezza',
    beam: 'Larghezza',
    engine: 'Motore',
    fuelCapacity: 'Serbatoio',
    maxSpeed: 'Velocità max',
  },

  // ============================================
  // DASHBOARD (GUEST)
  // ============================================
  dashboard: {
    title: 'Area Personale',
    greeting: 'Bentornato, {name}. Gestisci i tuoi noleggi in Sardegna.',
    profileSailor: 'Profilo Navigatore',
    menuUpcomingTrips: 'Prossimi Noleggi',
    menuPaymentMethods: 'Metodi di Pagamento',
    menuSaved: 'Salvati',
    menuPersonalInfo: 'Info Personali',
    confirmedBookings: 'Prenotazioni Confermate',
    pickupDate: 'Ritiro',
    returnDate: 'Riconsegna',
    receipt: 'Ricevuta',
    cancelBooking: 'Cancella',
    noTripsTitle: 'Nessun noleggio confermato',
    noTripsMessage: 'Il mare ti aspetta. Inizia a pianificare la tua prossima avventura!',
    exploreBoats: 'Esplora la Flotta',
    historyAndCancelled: 'Storico e Cancellate',
    statusCancelled: 'Cancellata',
    myBookings: 'Le Mie Prenotazioni',
    upcomingTrips: 'Prossimi Noleggi',
    paymentMethods: 'Metodi di Pagamento',
    saved: 'Salvati',
    personalInfo: 'Info Personali',
    noBookings: 'Nessun noleggio prenotato',
    noBookingsDesc: 'Il mare ti aspetta. Inizia a pianificare la tua prossima avventura!',
    savedComingSoon: 'Barche Salvate',
    savedDescription: 'Funzionalità in arrivo. Presto potrai salvare le tue barche preferite.',
  },

  // ============================================
  // ADMIN DASHBOARD
  // ============================================
  admin: {
    title: 'Dashboard Admin',
    subtitle: 'Gestione centralizzata InsulaCharter Sardegna.',
    addBoat: 'Aggiungi Barca',
    bookingsTitle: 'Prenotazioni',
    bookingsSubtitle: 'Gestisci le prenotazioni',

    // Boat port/marina (for external services matching)
    boatPortMarina: 'Porto/Marina',
    boatPortMarinaHint: 'I servizi esterni visibili ai clienti dipendono dal porto qui selezionato.',
    boatPortMarinaNone: '— Nessun porto —',
    boatPortMarinaLoading: 'Caricamento porti...',

    // Role management
    changeRole: 'Cambia Ruolo',
    changeRoleConfirm: 'Sei sicuro di voler cambiare il ruolo di questo utente?',
    changeRoleSuccess: 'Ruolo aggiornato con successo',
    changeRoleAdminWarning: 'Questo concede pieno accesso amministratore alla piattaforma.',
    changeRoleWarningBoats: 'Questo utente ha {count} barche attive. Il cambio di ruolo disattiverà i suoi annunci.',
    changeRoleForce: 'Procedi comunque',
    cannotChangeOwnRole: 'Non puoi modificare il tuo stesso ruolo',
    cannotDemoteLastAdmin: 'Impossibile: è l\'ultimo amministratore della piattaforma',
    roleAlreadyAssigned: 'L\'utente ha già questo ruolo',
    confirmAdminRequired: 'Conferma esplicita richiesta per promuovere ad Admin',
    invalidRole: 'Ruolo non valido',
    role_hub_internal_only: 'Questo account (ADMIN o Fornitore Servizi) si gestisce solo dall\'hub, non da qui.',
    newRole: 'Nuovo ruolo',
    vendorStatusOption: 'Stato vendor iniziale',

    // Service Provider invitations
    inviteServiceProvider: 'Invita Fornitore',
    inviteEmailLabel: 'Email del fornitore',
    inviteNameLabel: 'Nome (opzionale)',
    inviteDesc: 'Verrà inviata un\'email con un link di registrazione valido 48 ore.',
    inviteSend: 'Invia Invito',
    inviteSent: 'Invito inviato con successo',
    inviteAcceptTitle: 'Completa la Registrazione',
    inviteAcceptDesc: 'Sei stato invitato a unirti a InsulaCharter come Fornitore di Servizi.',

    // Preview links
    previewVendor: 'Anteprima Vendor',
    previewServiceProvider: 'Anteprima Fornitore',

    // Tabs
    tabDashboard: 'Panoramica',
    tabCalendar: 'Calendario',
    tabMyBoats: 'Flotta',
    tabReviews: 'Recensioni',
    tabBookings: 'Prenotazioni barche',
    tabClientBookings: 'Prenotazioni Clienti',
    tabServices: 'Servizi di Bordo',
    calendarTitle: 'Calendario Prenotazioni',
    calendarSubtitle: 'Visualizza tutte le prenotazioni della tua flotta',
    fleetOverview: 'Riepilogo Flotta',

    // Stats
    statsOverview: 'Panoramica Generale',
    statsTotalRevenue: 'Ricavi Totali',
    statsConfirmed: 'confermate',
    statsUniqueClients: 'Clienti Unici',
    statsRegisteredClients: 'clienti registrati',
    statsActiveBoats: 'Barche Attive',
    statsInFleet: 'nella flotta',
    statsPending: 'In Attesa',
    statsToConfirm: 'da confermare',

    // Economic averages
    economicAverages: 'Medie Economiche',
    avgBookingValue: 'Valore Medio Prenotazione',
    avgPricePerDay: 'Prezzo Medio Giornaliero',
    confirmationRate: 'Tasso di Conferma',

    // Booking trends
    bookingTrends: 'Andamento Prenotazioni',
    last30Days: 'Ultimi 30 Giorni',
    confirmedBookings: 'prenotazioni confermate',
    bookingStatus: 'Stato Prenotazioni',
    statusConfirmed: 'Confermate',
    statusPending: 'In Attesa',
    statusCancelled: 'Cancellate',

    // Pricing tabs
    tabPricingRules: 'Regole Prezzi',
    tabPricingCalendar: 'Calendario Prezzi',
    tabTariffe: 'Tariffe',
    tabTariffeReadonly: 'Tariffe (sola lettura)',
    tabPricing: 'Prezzi & Promozioni',

    // Pricing management (3-step flow)
    pricingTitle: 'Tariffe',
    pricingSubtitle: 'Naviga proprietari, barche e prezzi dettagliati',
    pricingBreadcrumbOwners: 'Tutti i proprietari',
    pricingSelectOwner: 'Seleziona un proprietario',
    pricingLoadingOwners: 'Caricamento proprietari...',
    pricingNoOwnersFound: 'Nessun proprietario trovato',
    pricingFilterAll: 'Tutti',
    pricingSearchOwner: 'Cerca nome o email...',
    pricingColOwner: 'Proprietario',
    pricingColEmail: 'Email',
    pricingColRole: 'Ruolo',
    pricingColBoats: 'Barche',
    pricingBoatsOf: 'Barche di',
    pricingBoatSingular: 'barca',
    pricingBoatPlural: 'barche',
    pricingNoBoats: 'Questo proprietario non ha barche registrate',
    pricingColBoatName: 'Barca',
    pricingColType: 'Tipo',
    pricingColLength: 'Lunghezza',
    pricingColPriceDay: '\u20AC/giorno',
    pricingColPriceHalf: '\u20AC/mezza',
    pricingColStatus: 'Stato',
    pricingBackToOwners: 'Torna ai proprietari',
    pricingBackToBoats: 'Torna alle barche di',
    pricingLoadingPricing: 'Caricamento tariffe...',
    pricingSearchBoats: 'Cerca barca...',
    pricingAllTypes: 'Tutti i tipi',
    pricingAllStatuses: 'Tutti gli stati',

    tabPricePolicies: 'Politiche Prezzo',
    tabCoupons: 'Coupons & Promotions',
    tabInviteCodes: 'Codici Invito',
    tabAmbassadors: 'Ambassador',
    tabAmbassadorTiers: 'Tier Ambassador',
    tabServicePlatformFee: 'Fee Servizi',
    tabExternalServicesPayout: 'Payout Servizi',
    usersRetrievalError: 'Errore nel recupero degli utenti',

    // Fleet management
    fleet: {
      title: 'Gestione Flotta',
      addBoat: 'Aggiungi Barca',
      filterAll: 'Tutte',
      filterCompany: 'Compagnie',
      filterVendor: 'Privati',
      filterPlatform: 'Piattaforma',
      searchPlaceholder: 'Cerca barca, proprietario, porto...',
      allTypes: 'Tutti i tipi',
      allPorts: 'Tutti i porti',
      clearFilters: 'Pulisci filtri',
      expandAll: 'Espandi tutto',
      collapseAll: 'Comprimi tutto',
      boat: 'barca',
      boats: 'barche',
      owner: 'proprietario',
      owners: 'proprietari',
      company: 'Compagnia',
      vendor: 'Vendor Privato',
      platform: 'Piattaforma',
      colBoat: 'Imbarcazione',
      colType: 'Tipo',
      colPort: 'Porto',
      colCapacity: 'Capacità',
      colPrice: 'Tariffa',
      colActions: 'Azioni',
      rentalDay: 'giorno',
      rentalWeek: 'settimana',
      rentalMonth: 'mese',
      viewDetails: 'Visualizza dettagli',
      edit: 'Modifica',
      delete: 'Elimina',
      empty: 'Nessuna barca nella flotta',
      emptyHint: 'Inizia aggiungendo la tua prima imbarcazione',
      noResults: 'Nessuna barca trovata',
      noResultsHint: 'Prova a modificare i filtri di ricerca',
    },

    // Promotions tab
    tabPromotions: 'Promozioni',
    tabSuspensions: 'Sospensioni',
    tabMobility: 'Servizi Esterni',
    tabMobilityServices: 'Catalogo Servizi',
    tabExtraCategories: 'Categorie Servizi',
    tabExternalServices: 'Servizi Esterni (API)',
    apiCatalogTitle: 'Catalogo Servizi da InsulaServices',
    apiCatalogDesc: 'Servizi disponibili da insulaservices.it per le barche. Clicca "Sincronizza" per aggiornare.',
    apiCatalogSync: 'Sincronizza',
    apiCatalogSyncing: 'Sincronizzazione...',
    apiCatalogEmpty: 'Nessun servizio disponibile. Prova a sincronizzare.',
    apiCatalogError: 'Errore nel contattare insulaservices.it',
    apiCatalogQuote: 'Su richiesta',
    apiCatalogPerPerson: '/persona',
    extraCategoriesTitle: 'Categorie Servizi',
    extraCategoriesDesc: 'Crea e gestisci le categorie dei servizi extra. Le categorie marcate "esterne" sono visibili ai clienti e selezionabili dai Service Provider.',
    extraCategoriesNew: 'Nuova categoria',
    extraCategoriesEdit: 'Modifica categoria',
    extraCategoriesEmpty: 'Nessuna categoria configurata',
    extraCategoriesSlug: 'Slug (ID univoco)',
    extraCategoriesLabel: 'Etichetta',
    extraCategoriesDescription: 'Descrizione',
    extraCategoriesIcon: 'Icona',
    extraCategoriesIconHint: 'Nome di un\'icona Lucide (es. Bike, Camera, Utensils, Anchor)',
    extraCategoriesColor: 'Colore badge',
    extraCategoriesSortOrder: 'Ordinamento',
    extraCategoriesVisibility: 'Visibilità',
    extraCategoriesExternal: 'Esterna (visibile ai clienti)',
    extraCategoriesExternalShort: 'esterna',
    extraCategoriesInternal: 'Interna (solo admin)',
    extraCategoriesInternalShort: 'interna',
    extraCategoriesProtected: 'Categoria protetta — non può essere eliminata',
    extraCategoriesProtectedHint: 'Le categorie protette non possono cambiare slug né visibilità',
    extraCategoriesUsage: 'in uso',
    extraCategoriesMoveUp: 'Sposta su',
    extraCategoriesMoveDown: 'Sposta giù',
    extraCategoriesValidation: 'Slug ed etichetta sono obbligatori',
    extraCategoriesCreated: 'Categoria creata',
    extraCategoriesUpdated: 'Categoria aggiornata',
    extraCategoriesDeleted: 'Categoria eliminata',
    extraCategoriesConfirmDelete: 'Eliminare definitivamente questa categoria?',
    mobilityServices: 'Servizi di Mobilità',
    mobilityServicesDesc: 'Gestisci bici, scooter, monopattini e transfer disponibili per i clienti',
    noMobilityServices: 'Nessun servizio di mobilità configurato',
    tabTransferOverview: 'Trasferimenti',
    transferOverview: 'Panoramica Trasferimenti',
    unassigned: 'Non assegnato',
    tabServiceProviders: 'Fornitori Servizi',
    tabServiceRequests: 'Richieste Servizi',
    serviceProviders: 'Fornitori di Servizi',
    serviceProvidersDesc: 'Gestisci i fornitori che erogano servizi di mobilità e transfer',
    addProvider: 'Aggiungi Fornitore',
    noProviders: 'Nessun fornitore registrato',
    selectUser: 'Seleziona Utente',
    selectService: 'Seleziona Servizio',
    maxCapacity: 'Capacità Massima',
    serviceRequests: 'Richieste di Servizio',
    serviceRequestsDesc: 'Panoramica di tutte le richieste di servizio dalle prenotazioni',
    noServiceRequests: 'Nessuna richiesta di servizio',
    // Mobility sub-tab extras
    tabMobilityOverview: 'Panoramica',
    mobilityOverview: 'Panoramica Mobilità',
    mobilityOverviewDesc: 'Statistiche globali su fornitori e richieste di servizio',
    mobilityProvidersTotal: 'Fornitori totali',
    mobilityProvidersActive: 'Fornitori attivi',
    mobilityProvidersInactive: 'Fornitori disattivi',
    mobilityRequestsTotal: 'Richieste totali',
    mobilityTopProviders: 'Top 5 fornitori (richieste completate)',
    mobilityNoTopProviders: 'Nessun fornitore con richieste completate',
    mobilityRefresh: 'Aggiorna',
    mobilityLoadError: 'Errore caricamento dati mobilità',
    mobilityOpenSpDashboard: 'Apri dashboard SP',
    mobilityPendingBadge: '{count} in attesa',
    mobilityStatusActive: 'Attivo',
    mobilityStatusInactive: 'Disattivo',
    mobilityEditName: 'Nome',
    mobilityEditPrice: 'Prezzo (€)',
    mobilityEditPriceType: 'Tipo prezzo',
    mobilityEditDescription: 'Descrizione',
    mobilityEnable: 'Attiva',
    mobilityDisable: 'Disattiva',
    mobilityLabelCapacity: 'Cap.',
    mobilityLabelProvider: 'Fornitore',
    mobilityLabelQuantity: 'Qtà',
    mobilityToggleError: 'Impossibile aggiornare lo stato del servizio',
    mobilitySaveError: 'Impossibile salvare le modifiche',
    mobilityLoadProvidersError: 'Impossibile caricare i fornitori',
    mobilityLoadRequestsError: 'Impossibile caricare le richieste',
    // External services moderation
    externalServicesTitle: 'Servizi Esterni',
    externalServicesDesc: 'Modera e gestisci i servizi creati dai Service Provider',
    externalServicesPending: 'In attesa di approvazione',
    externalServicesApprove: 'Approva',
    externalServicesReject: 'Rifiuta',
    externalServicesRejectReason: 'Motivo del rifiuto',
    externalServicesNotes: 'Note (visibili al SP)',
    externalServiceCreator: 'Creato da',
    externalServiceCreatorAdmin: 'Admin (piattaforma)',
    externalServicePorts: 'Porti operativi',
    externalServiceNoPort: 'Nessun porto associato',
    // Price type labels
    priceType_per_stay: 'Per soggiorno',
    priceType_per_day: 'Al giorno',
    priceType_per_night: 'A notte',
    priceType_per_person: 'A persona',
    priceType_per_person_per_day: 'A persona/giorno',
    priceType_per_person_per_night: 'A persona/notte',
    confirmDelete: 'Sei sicuro di voler eliminare?',
    tabPoi: 'Punti di Interesse',
    tabPorts: 'Porti',
    reassign: 'Riassegna',
    promoTitle: 'Titolo',
    promoSubtitle: 'Sottotitolo',
    promoDescription: 'Descrizione',
    promoImage: 'Immagine',
    promoCtaText: 'Testo CTA',
    promoCtaLink: 'Link CTA',
    promoBadge: 'Badge',
    promoStartDate: 'Data Inizio',
    promoEndDate: 'Data Fine',
    promoActive: 'Attiva',
    promoOrder: 'Ordine',
    promoNew: 'Nuova Promozione',
    promoEdit: 'Modifica Promozione',
    promoDelete: 'Elimina Promozione',
    promoDeleteConfirm: 'Sei sicuro di voler eliminare questa promozione?',
    promoCreated: 'Promozione creata con successo',
    promoUpdated: 'Promozione aggiornata con successo',
    promoDeleted: 'Promozione eliminata con successo',
    promoNoResults: 'Nessuna promozione trovata',
    promoAlwaysVisible: 'Sempre visibile',
    promoSave: 'Salva',
    promoCancel: 'Annulla',
    promoUploadImage: 'Carica immagine',
    promoOrImageUrl: 'oppure inserisci URL immagine',
    promoToggleActive: 'Attiva/Disattiva',
    promoReorderHint: 'Usa le frecce per riordinare',
    promoMoveUp: 'Sposta su',
    promoMoveDown: 'Sposta giù',

    // Trends tab
    tabTrends: 'Andamento',
    trendsTotalRevenue: 'Ricavi Periodo',
    trendsMonthlyAvg: 'Media Mensile',
    trendsPerMonth: 'per mese',
    trendsTrend: 'Trend',
    trendsVsPrev: 'vs periodo precedente',
    trendsBookings: 'Prenotazioni',
    trendsRevenue: 'Ricavi',

    // Recent bookings table
    recentBookings: 'Ultime Prenotazioni',
    tableDate: 'Data',
    tableBoat: 'Barca',
    tablePickupReturn: 'Ritiro/Riconsegna',
    tableValue: 'Valore',
    tableStatus: 'Stato',
    noBookingsYet: 'Nessuna prenotazione ancora',
    clientProfile: 'Profilo Cliente',
    bookingHistory: 'Storico Prenotazioni',
    totalSpent: 'Totale Speso',
    cancellationReason: 'Motivo cancellazione',
    confirmBooking: 'Conferma prenotazione',
    cancelBooking: 'Cancella prenotazione',
    completeBooking: 'Completa prenotazione',
    refundDeposit: 'Rimborsa acconto',
    depositRefunded: 'Acconto rimborsato',

    // Boats table
    tableVessel: 'Imbarcazione',
    tablePort: 'Porto',
    tableRate: 'Tariffa',
    tableActions: 'Azioni',

    // Bookings table
    tableClients: 'Clienti',
    tablePeriod: 'Periodo',
    tableTotal: 'Totale',
    tablePaymentStatus: 'Pagamento',
    vendorSuspended: 'Vendor sospeso',
    vendorBookingsSuspended: 'Prenotazioni sospese',
    boatName: 'Barca',
    email: 'Email',
    embarkation: 'Imbarco',
    disembarkation: 'Sbarco',
    deposit: 'Caparra',

    // Booking list/calendar view
    allStatuses: 'Tutte',
    allPaymentStatuses: 'Tutti i pagamenti',
    paymentPending: 'Da pagare',
    paymentPaid: 'Pagato',
    paymentPartial: 'Parziale',
    paymentRefunded: 'Rimborsato',
    calendarView: 'Calendario',
    listView: 'Lista',
    searchGuest: 'Cerca cliente...',
    cancelWithReason: 'Cancella con motivo',
    cancelConfirmMessage: 'Sei sicuro di voler cancellare questa prenotazione?',
    cancelReasonPlaceholder: 'Motivo della cancellazione (opzionale)',

    // Summary cards
    pendingBookings: 'In Attesa',
    confirmedRevenue: 'Ricavi Confermati',

    // Booking detail modal
    bookingDetail: 'Dettaglio Prenotazione',
    guestInfo: 'Informazioni Cliente',
    firstName: 'Nome',
    boatInfo: 'Informazioni Barca',
    port: 'Porto',
    rentalDetails: 'Dettagli Noleggio',
    experienceDetails: 'Dettagli Esperienza',
    priceSummary: 'Riepilogo Prezzo',
    basePrice: 'Prezzo base',
    insuranceFee: 'Assicurazione',
    extras: 'Extra',
    specialRequests: 'Richieste Speciali',
    downloadReceipt: 'Ricevuta',
    noBookingsFound: 'Nessuna prenotazione trovata',

    // Reversible bookings
    reversibleBookings: 'Prenotazioni Annullabili',
    reversibleBookingsSubtitle: 'Puoi ripristinare lo stato precedente',
    reverse: 'Ripristina',
    undo: 'Annulla',

    // Calendar overview
    boatsOverview: 'Riepilogo Barche',
    confirmedShort: 'conferm.',
    pendingShort: 'in attesa',
    blockedShort: 'bloccati',

    // Services section
    includedServices: 'Dotazioni di Bordo',
    includedServicesSubtitle: 'Gestisci le dotazioni incluse nelle barche',
    addEquipment: 'Aggiungi Dotazione',
    extraServices: 'Servizi Extra (a Pagamento)',
    extraServicesSubtitle: 'Gestisci i servizi extra che possono essere aggiunti ai noleggi. Il prezzo viene impostato per ogni barca.',
    addExtraService: 'Aggiungi Servizio Extra',

    // Extras approval (admin)
    extraFilterAll: 'Tutti',
    extraFilterPlatform: 'Piattaforma',
    extraFilterVendors: 'Vendor',
    extraFilterPending: 'In attesa',
    extraCreatorPlatform: 'Piattaforma',
    extraCreatorLabel: 'Creato da',
    extraApprove: 'Approva',
    extraReject: 'Rifiuta',
    extraRejectNotes: 'Motivo del rifiuto',
    extraRejectNotesPlaceholder: 'Spiega il motivo del rifiuto...',
    extraPendingCount: 'extra in attesa',
    extraApproved: 'Extra approvato',
    extraRejected: 'Extra rifiutato',
    extraApproveError: 'Errore nell\'approvazione',
    extraRejectError: 'Errore nel rifiuto',
    extraPromote: 'Rendi globale',
    extraPromoted: 'Extra promosso a servizio globale della piattaforma',
    extraPromoteError: 'Errore nella promozione',
    extraPromoteConfirm: 'Rendere questo extra disponibile per tutte le barche della piattaforma? Il vendor perderà la proprietà esclusiva.',

    // Audit History
    auditTitle: 'Cronologia Operazioni',
    auditSubtitle: 'Storico completo delle operazioni su servizi extra per tracciabilità e contenziosi',
    auditTotalEntries: 'operazioni registrate',
    auditNoEntries: 'Nessuna operazione registrata',
    auditDetails: 'Dettagli operazione',
    auditPage: 'Pagina',

    tableService: 'Servizio',
    tableDescription: 'Descrizione',
    tableIcon: 'Icona',

    // Boat modal
    modalNewBoat: 'Nuova Barca InsulaCharter',
    modalEditBoat: 'Modifica Barca InsulaCharter',
    formBoatName: 'Nome Barca',
    formBoatNamePlaceholder: 'es: Azzurra',
    formPort: 'Porto Base',
    formPortPlaceholder: 'es: Porto Cervo',
    formPricePerDay: 'Prezzo Giornaliero (€)',
    formInsuranceFee: 'Assicurazione (€)',
    formDescription: 'Descrizione',
    formDescriptionPlaceholder: 'Descrivi le caratteristiche di questa barca...',

    // Photos section
    photosSection: 'Foto Barca',
    photoCover: 'Copertina',
    photoSetCover: 'Usa come Copertina',
    addPhoto: 'Aggiungi Foto',
    addPhotoMaxReached: 'Aggiungi Foto (Massimo raggiunto)',

    // Specifications
    specifications: 'Specifiche Tecniche',
    formLength: 'Lunghezza (m)',
    formBeam: 'Larghezza (m)',
    formCapacity: 'Capacità Passeggeri',
    formEngine: 'Motorizzazione',
    formLicenseRequired: 'Richiede Patente Nautica',

    // Services in boat
    onboardEquipment: 'Dotazioni di Bordo',
    extraServicesPaid: 'Servizi Extra (a pagamento)',
    extraServicesCustomPrice: 'Imposta i prezzi personalizzati per questa barca',

    // Buttons
    saveChanges: 'Salva Modifiche',
    createListing: 'Pubblica Barca',

    // Equipment modal
    modalNewEquipment: 'Nuova Dotazione',
    modalEditEquipment: 'Modifica Dotazione',
    formServiceId: 'ID Servizio',
    formServiceIdPlaceholder: 'es: tendalino_parasole',
    formServiceIdHelper: 'Usare solo lettere minuscole e underscore',
    formServiceName: 'Nome Servizio',
    formServiceNamePlaceholder: 'es: Tendalino Parasole',
    formServiceDescriptionPlaceholder: 'Descrivi la dotazione...',
    formIconOptional: 'Icona (opzionale)',
    iconDefault: 'Info (default)',
    iconAnchor: 'Ancora',
    iconLifeBuoy: 'Salvagente',
    iconCompass: 'Bussola',
    iconSun: 'Sole',
    iconWaves: 'Onde',
    iconWind: 'Vento',
    iconFuel: 'Carburante',
    iconRadio: 'Radio',
    iconGps: 'GPS',

    // Extra modal
    modalNewExtra: 'Nuovo Servizio Extra',
    modalEditExtra: 'Modifica Servizio Extra',
    formExtraIdPlaceholder: 'es: skipper_servizio',
    formExtraNamePlaceholder: 'es: Skipper Professionista',
    formExtraDescriptionPlaceholder: 'Descrivi il servizio extra...',
    extraPriceInfo: 'Il prezzo del servizio verrà impostato individualmente per ogni barca.',

    // Multilingual translations
    translationsSection: 'Traduzioni',
    translationsHelper: 'Inserisci le traduzioni per ogni lingua supportata',
    translationsHelperAuto: 'Inserisci il testo in italiano e clicca "Traduci automaticamente" per generare le altre traduzioni.',
    autoTranslate: 'Traduci automaticamente',
    translating: 'Traduzione...',
    translationComplete: 'Traduzione completata!',
    translationFailed: 'Errore nella traduzione',
    enterItalianFirst: 'Inserisci prima il testo in italiano',
    sourceLang: 'Lingua sorgente',
    labelIT: 'Nome (Italiano)',
    labelEN: 'Nome (Inglese)',
    labelDE: 'Nome (Tedesco)',
    descriptionIT: 'Descrizione (Italiano)',
    descriptionEN: 'Descrizione (Inglese)',
    descriptionDE: 'Descrizione (Tedesco)',
    langIT: 'Italiano',
    langEN: 'Inglese',
    langDE: 'Tedesco',

    // Category options
    formCategory: 'Categoria',
    categoryGeneral: 'Servizio generale',
    categorySafety: 'Sicurezza',
    categoryComfort: 'Comfort',
    categoryNavigation: 'Navigazione',
    categoryEntertainment: 'Intrattenimento',
    categorySpecial: 'Servizio speciale (badge verde)',

    // Blocked Dates
    allBoats: 'Tutte le barche',
    blockDates: 'Blocca Date',
    blockDatesTitle: 'Blocca Date',
    blockedPeriods: 'Periodi Bloccati',
    blocked: 'bloccati',
    unblock: 'Sblocca',
    blockingFor: 'Blocco date per',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    blockReason: 'Motivo (opzionale)',
    blockReasonPlaceholder: 'es: Manutenzione, Uso personale...',
    blockWarning: 'Le date bloccate non saranno disponibili per nuovi noleggi e verranno mostrate come "non disponibili" agli utenti.',
    confirmBlock: 'Blocca Date',
    selectBoatFirst: 'Seleziona prima una barca',
    selectDatesFirst: 'Seleziona le date',
    datesBlocked: 'Date bloccate con successo',
    datesUnblocked: 'Date sbloccate',
    confirmUnblock: 'Vuoi sbloccare queste date?',
    tabSettings: 'Impostazioni',
    tabClients: 'Clienti',
    tabClientManagement: 'Clienti',

    // Clients section
    clientsTitle: 'Gestione Clienti',
    searchClients: 'Cerca per nome o email...',
    searchBookings: 'Cerca cliente, email...',
    noClients: 'Nessun cliente registrato',
    tableClient: 'Cliente',
    tableEmail: 'Email',
    tableBookingsCount: 'Prenotazioni',
    tableTotalSpent: 'Totale Speso',
    tableRegistered: 'Registrato il',
    registeredOn: 'Registrato il',
    totalBookings: 'Totale',
    viewClient: 'Visualizza Cliente',
    clientConfirmedBookings: 'Confermate',
    clientPendingBookings: 'In Attesa',
    clientCancelledBookings: 'Cancellate',
    emailVerified: 'Email Verificata',
    emailNotVerified: 'Email Non Verificata',

    // Admin User Management
    userManagement: 'Gestione Avanzata',
    userManagementDesc: 'Azioni amministrative per questo utente',
    resetEmailVerification: 'Reset Verifica Email',
    resetEmailVerificationDesc: 'Reimposta lo stato di verifica email. L\'utente dovrà verificare nuovamente la propria email.',
    resetEmailVerificationSuccess: 'Verifica email reimpostata con successo',
    resetPassword: 'Reset Password',
    resetPasswordDesc: 'Invia una email di reset password all\'utente.',
    resetPasswordSuccess: 'Email di reset password inviata',
    resetPasswordEmailFailed: 'Impossibile inviare email. Token generato per uso manuale.',
    emailNotConfigured: 'Email non configurata. Token generato per uso manuale.',
    userNotFound: 'Utente non trovato',
    confirmAction: 'Conferma Azione',
    confirmResetEmailVerification: 'Sei sicuro di voler reimpostare la verifica email per questo utente?',
    confirmResetPassword: 'Sei sicuro di voler inviare una email di reset password a questo utente?',
    // Suspension
    suspendUser: 'Sospendi Utente',
    suspendUserDesc: 'Blocca l\'accesso alla piattaforma e impedisci nuove prenotazioni.',
    unsuspendUser: 'Riattiva Utente',
    unsuspendUserDesc: 'Ripristina l\'accesso completo alla piattaforma.',
    suspendUserSuccess: 'Utente sospeso con successo',
    unsuspendUserSuccess: 'Utente riattivato con successo',
    confirmSuspendUser: 'Sei sicuro di voler sospendere questo utente? Non potrà più accedere alla piattaforma.',
    confirmUnsuspendUser: 'Sei sicuro di voler riattivare questo utente?',
    suspensionReason: 'Motivo della sospensione',
    suspensionReasonPlaceholder: 'Es: Violazione termini di servizio, pagamenti fraudolenti...',
    suspended: 'Sospeso',
    suspendedSince: 'Sospeso dal',
    accountSuspended: 'Account Sospeso',
    accountSuspendedDesc: 'Il tuo account è stato sospeso. Contatta il supporto per maggiori informazioni.',
    suspendCompanyDesc: 'Blocca l\'accesso alla piattaforma, impedisci nuove prenotazioni e nascondi le barche dal catalogo.',

    // Monitoring / Logs
    tabMonitoring: 'Monitoraggio',
    tabLogs: 'Log eventi',
    tabRawConsole: 'Console raw',
    logs: {
      title: 'Log di sistema',
      description: 'Registro eventi e attività della piattaforma',
      filterCategory: 'Categoria',
      filterLevel: 'Livello',
      filterFrom: 'Dal',
      filterTo: 'Al',
      filterSearch: 'Cerca nel messaggio...',
      filterActor: 'Utente (ID)',
      reset: 'Reset',
      exportCsv: 'Esporta CSV',
      columns: {
        timestamp: 'Data',
        level: 'Livello',
        category: 'Categoria',
        action: 'Azione',
        actor: 'Utente',
        target: 'Target',
        message: 'Messaggio',
        ip: 'IP',
        details: 'Dettagli',
      },
      detailsTitle: 'Dettagli evento',
      metadata: 'Metadati',
      requestId: 'Request ID',
      empty: 'Nessun evento',
      loading: 'Caricamento log...',
      page: 'Pagina {{n}} di {{total}}',
      levels: {
        all: 'Tutti',
        info: 'Info',
        warn: 'Warning',
        error: 'Error',
      },
      categories: {
        all: 'Tutte',
        auth: 'Autenticazione',
        ambassador: 'Ambassador',
        booking: 'Prenotazioni',
        payment: 'Pagamenti',
        admin: 'Admin',
        system: 'Sistema',
        http: 'HTTP',
      },
    },

    bookings: {
      actionCancel: 'Annulla',
      actionHardDelete: 'Elimina definitivamente',
      paymentMethod: 'Metodo pagamento',
      amountPaid: 'Importo pagato',
      confirmCancel: 'Conferma annullamento',

      hardDeleteTitle: 'Eliminazione definitiva',
      hardDeleteWarningTitle: 'ELIMINAZIONE DEFINITIVA — IRREVERSIBILE',
      hardDeleteWarning: 'Questa operazione cancella per sempre la prenotazione dal database. Usala solo per dati di test, mai in produzione.',
      hardDeleteConfirmType: 'Per confermare digita "{keyword}"',
      hardDeleteConfirm: 'Elimina definitivamente',

      cancelRefundTitle: 'Annulla prenotazione e rimborsa',
      refundPreview: 'Importo da rimborsare',
      refundPolicy: 'Policy applicata',
      refundViaMollie: 'Rimborsa automaticamente via Mollie',
      refundViaMollieDesc: 'Mollie processa il rimborso sulla stessa carta usata dal cliente.',
      refundManualWarningTitle: 'Rimborso manuale necessario',
      refundManualWarning: 'Pagamento via {gateway}: dopo l\'annullamento dovrai contrassegnare manualmente l\'avvenuto rimborso dal dettaglio prenotazione.',
      refundPendingBox: 'Rimborso manuale richiesto',
      markRefunded: 'Segna come rimborsato',
      waiveRefund: 'Rinuncia rimborso',
      refundNote: 'Note (opzionale)',
      refundNotePlaceholder: 'Motivo annullamento o nota interna...',

      statusRefundPending: 'Rimborso in attesa',
      statusRefundProcessing: 'Rimborso in corso',
      statusRefundFailed: 'Rimborso fallito',
      statusRefundWaived: 'Rimborso rinunciato',

      toastCancelSuccess: 'Prenotazione annullata',
      toastRefundedMollie: 'Rimborsata via Mollie',
      toastRefundPending: 'Annullata. Rimborso manuale in attesa',
      toastRefundProcessing: 'Annullata. Rimborso in elaborazione',
      toastRefundFailed: 'Rimborso Mollie fallito — riprova manualmente',
      toastDeleted: 'Prenotazione eliminata definitivamente',
      toastMarkedRefunded: 'Prenotazione segnata come rimborsata',
      toastRefundWaived: 'Rinuncia al rimborso registrata',

      forceRefundTitle: 'Rimborso Mollie non registrato',
      forceRefundDesc: 'Questa prenotazione è stata annullata ma il rimborso Mollie non è stato eseguito. Puoi forzarlo manualmente ora.',
      forceRefundPaid: 'Importo pagato',
      forceRefundAmount: 'Importo da rimborsare',
      forceRefundBtn: 'Forza rimborso su Mollie',
      forceRefundConfirm: 'Confermi il rimborso di €{amount} su Mollie?',
      forceRefundSuccess: 'Rimborso eseguito su Mollie (€{amount})',
      forceRefundError: 'Errore nel rimborso',
      forceRefundMollieId: 'Mollie payment ID',
    },

    settings: {
      securityTitle: 'Sicurezza & Test',
      securityDesc: 'Operazioni distruttive e funzionalità riservate al testing',
      hardDeleteToggle: 'Consenti eliminazione definitiva prenotazioni',
      hardDeleteDescription: 'Solo per ambienti di test. Se attivo, gli admin potranno cancellare permanentemente le prenotazioni dal database. In produzione lasciare disattivato.',
      hardDeleteOn: 'ATTIVO',
      hardDeleteOff: 'DISATTIVO',
      hardDeleteWarningProd: 'ATTENZIONE: in produzione questa opzione deve restare DISATTIVATA. Le eliminazioni sono irreversibili e cancellano dati storici di pagamenti, ricevute e audit.',
    },
  },

  // ============================================
  // SETTINGS
  // ============================================
  settings: {
    title: 'Configurazione',
    subtitle: 'Gestisci le impostazioni del sistema',
    saved: 'Impostazione salvata',
    invalidDays: 'Inserisci un valore tra 1 e 90',

    // Dashboard Layout
    dashboardLayout: 'Layout Dashboard',
    dashboardLayoutDesc: 'Scegli come raggruppare le tab nelle dashboard admin e vendor',
    layoutAdmin: 'Dashboard Admin',
    layoutVendor: 'Dashboard Vendor',
    layoutA: 'Compatto',
    layoutADesc: 'Raggruppa le tab in poche macro-sezioni',
    layoutB: 'Priorità operativa',
    layoutBDesc: 'Bilancio tra visibilità e raggruppamento',
    layoutC: 'Ultra-compatto',
    layoutCDesc: 'Numero minimo di tab principali',
    layoutTabs: 'tab',
    layoutCurrent: 'Attuale',

    // Admin tab group labels
    layoutAdminFleet: 'Flotta',
    layoutAdminOperations: 'Operazioni',
    layoutAdminClientsServices: 'Clienti & Servizi',
    layoutAdminMarketplace: 'Marketplace',
    layoutAdminFinance: 'Finanza',
    layoutAdminManagement: 'Gestione',

    // Vendor tab group labels
    layoutVendorFleet: 'Flotta',
    layoutVendorOperations: 'Operazioni',
    layoutVendorServicesClients: 'Servizi & Clienti',
    layoutVendorManagement: 'Gestione',

    // Sub-tab labels
    subtabStats: 'Statistiche',
    subtabVendors: 'Vendor',
    subtabBoatApproval: 'Approvazione Barche',
    subtabRevenue: 'Revenue',
    subtabPayouts: 'Payout',
    subtabPlatformStats: 'Piattaforma',
    autoCancellation: 'Cancellazione Automatica Prenotazioni Pending',
    autoCancellationDesc: 'Quando abilitato, le prenotazioni in stato "In Attesa" verranno automaticamente cancellate dopo il numero di giorni specificato.',
    enableAutoCancel: 'Abilita cancellazione automatica',
    autoCancelEnabled: 'Le prenotazioni pending scadute verranno cancellate automaticamente',
    autoCancelDisabled: 'Le prenotazioni pending non verranno cancellate automaticamente',
    daysBeforeCancel: 'Giorni prima della cancellazione',
    daysBeforeCancelDesc: 'Numero di giorni dopo i quali una prenotazione pending viene cancellata (1-90)',
    howItWorks: 'Come funziona',
    howItWorksDesc: 'Il sistema controlla ogni giorno a mezzanotte le prenotazioni in stato "In Attesa" (PENDING). Se una prenotazione è stata creata più del numero di giorni specificato e non è stata ancora confermata, viene automaticamente cancellata con il motivo "Scadenza automatica".',

  },

  // ============================================
  // AUTH - LOGIN
  // ============================================
  login: {
    title: 'Bentornato',
    subtitle: 'Accedi al tuo account',
    emailLabel: 'Email',
    emailPlaceholder: 'tua@email.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    submitButton: 'Accedi',
    submittingButton: 'Accesso...',
    noAccount: 'Non hai un account? Registrati',
    partnerRedirect: 'I partner devono accedere da partner.insulacharter.it',
    testAccounts: 'Account di test:',
    testGuest: 'Guest: turista@example.com',
    testAdmin: 'Admin: info@insulacharter.it',
    testPassword: 'Password: InsulaHost2026!',
    forgotPassword: 'Password dimenticata?',
  },

  // ============================================
  // AUTH - FORGOT PASSWORD
  // ============================================
  forgotPassword: {
    title: 'Password dimenticata',
    description: 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
    submitButton: 'Invia link di reset',
    emailSentTitle: 'Email inviata!',
    emailSentDescription: 'Se l\'email è registrata, riceverai un link per reimpostare la password. Controlla anche la cartella spam.',
    backToLogin: 'Torna al login',
  },

  // ============================================
  // AUTH - RESET PASSWORD
  // ============================================
  resetPassword: {
    title: 'Nuova password',
    description: 'Scegli una nuova password per il tuo account.',
    newPasswordLabel: 'Nuova password',
    newPasswordPlaceholder: 'Inserisci la nuova password',
    confirmPasswordLabel: 'Conferma password',
    confirmPasswordPlaceholder: 'Ripeti la nuova password',
    submitButton: 'Reimposta password',
    successTitle: 'Password reimpostata!',
    successDescription: 'La tua password è stata aggiornata. Verrai reindirizzato al login...',
    invalidLink: 'Link non valido',
    invalidLinkDescription: 'Il link di reset è mancante o non valido. Richiedi un nuovo link.',
    requestNewLink: 'Richiedi nuovo link',
    passwordMismatch: 'Le password non corrispondono',
  },

  // ============================================
  // AUTH - PARTNER LOGIN
  // ============================================
  partnerLogin: {
    title: 'Partner Portal',
    subtitle: 'InsulaCharter — Area Riservata',
    sectionLabel: 'Accesso Partner',
    emailPlaceholder: 'email@esempio.it',
    submit: 'Accedi',
    submitting: 'Accesso in corso...',
    accessDenied: 'Quest\'area è riservata ai partner. Accedi dal sito principale.',
    copyright: 'Tutti i diritti riservati.',
  },

  // ============================================
  // PROFILO PARTNER (completamento)
  // ============================================
  partnerProfile: {
    tab: { anagrafica: 'Anagrafica', documenti: 'Documenti', account: 'Account' },
    header: { verified: 'Verificato', pending: 'In verifica', ibanMissing: 'IBAN da impostare', manageIban: 'Impostazioni' },
    role: { VENDOR: 'Operatore', COMPANY: 'Azienda', ADMIN: 'Admin' },
    completionTitle: 'Completamento profilo',
    missing: 'Mancano',
    allDone: 'Profilo completo',
    loading: 'Caricamento profilo…',
    loadError: 'Errore nel caricamento del profilo',
    saved: 'Profilo aggiornato',
    saveError: 'Errore nel salvataggio',
    notSet: 'Non impostato',
    managePayout: 'Gestisci in Impostazioni → Pagamenti & Incassi',
    save: 'Salva profilo',
    saving: 'Salvataggio…',
    badgeComplete: 'Completo',
    badgeMissingOne: 'mancante',
    badgeMissingMany: 'mancanti',
    bioPlaceholder: 'Descrivi la tua attività (min 30 caratteri)…',
    bioHelper: 'Almeno 30 caratteri.',
    seasonHint: 'Default per tutta la flotta. Lascia vuoti per "sempre aperta".',
    seasonFrom: 'Da',
    seasonTo: 'A',
    docsHint: 'I documenti vengono verificati dal team InsulaCharter.',
    docsUpload: 'Carica',
    docsReplace: 'Sostituisci',
    docStatusMissing: 'Da caricare',
    docStatusPending: 'In verifica',
    docStatusApproved: 'Verificato',
    docStatusRejected: 'Rifiutato',
    docUploadError: 'Errore nel caricamento',
    docUploadOk: 'Documento caricato',
    emailVerifyTitle: 'Verifica email',
    changePassword: 'Cambia password',
    currentPassword: 'Password attuale',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma nuova password',
    pwUpdate: 'Aggiorna password',
    pwUpdating: 'Aggiorno…',
    pwMismatch: 'Le nuove password non coincidono',
    pwTooShort: 'La nuova password deve avere almeno 8 caratteri',
    pwUpdated: 'Password aggiornata',
    pwError: 'Errore durante il cambio password',
    forgotTitle: 'Password dimenticata?',
    forgotDesc: 'Ricevi un link via email per reimpostare la password.',
    forgotCta: 'Recupera password →',
    suspendedOk: 'Prenotazioni sospese',
    reactivatedOk: 'Prenotazioni riattivate',
    section: {
      company: 'Dati azienda',
      address: 'Indirizzo sede',
      personal: 'Dati personali',
      payout: 'Dati payout',
      presentation: 'Presentazione',
      documents: 'Documenti aziendali',
      season: 'Stagione apertura prenotazioni',
      account: 'Account e sicurezza',
    },
    field: {
      company_name: 'Ragione sociale',
      company_vat: 'Partita IVA',
      company_pec: 'PEC',
      company_sdi: 'Codice SDI',
      vendor_phone: 'Telefono',
      address_street: 'Indirizzo',
      address_city: 'Città',
      address_province: 'Provincia',
      address_postal_code: 'CAP',
      payout_iban: 'IBAN',
      payout_holder: 'Intestatario conto',
      vendor_bio: 'Bio / descrizione',
      email_verified: 'Email verificata',
      name: 'Nome',
      email: 'Email',
      BUSINESS_REGISTRATION: 'Visura camerale',
      VAT_CERTIFICATE: 'Certificato P.IVA',
      INSURANCE: 'Polizza RC',
    },
  },

  // BOOKING SUSPENDED OVERLAY
  // ============================================
  suspended: {
    title: 'Prenotazioni temporaneamente sospese',
    description: 'Stiamo aggiornando il sistema di prenotazione. Lascia la tua email e ti avviseremo appena sarà possibile prenotare.',
    notifyLabel: 'Vuoi essere avvisato?',
    emailPlaceholder: 'La tua email',
    notifyBtn: 'Avvisami alla riapertura',
    sending: 'Invio in corso...',
    error: 'Si è verificato un errore. Riprova.',
    vendorTitle: 'Prenotazioni partner sospese',
    vendorDescription: 'Questo partner ha temporaneamente sospeso le prenotazioni per le sue barche.',
    boatTitle: 'Prenotazioni barca sospese',
    boatDescription: 'Le prenotazioni per questa barca sono temporaneamente sospese.',
    suspendVendorBookings: 'Sospendi prenotazioni partner',
    unsuspendVendorBookings: 'Riattiva prenotazioni partner',
    suspendVendorBookingsDesc: 'Blocca le prenotazioni per tutte le barche di questo partner.',
    suspendMyBookings: 'Sospendi le mie prenotazioni',
    unsuspendMyBookings: 'Riattiva le mie prenotazioni',
    suspendMyBookingsDesc: 'Metti in pausa le prenotazioni per tutte le tue barche (es. periodo di vacanza).',
    suspendBoatBookings: 'Sospendi prenotazioni',
    unsuspendBoatBookings: 'Riattiva prenotazioni',
    byAdmin: 'Sospeso dall\'amministratore',
  },

  // ============================================
  // COOKIE CONSENT
  // ============================================
  cookie: {
    title: 'Privacy a Bordo',
    description: 'Utilizziamo i cookie per offrirti un\'esperienza di navigazione ottimale e personalizzare i tuoi prossimi itinerari in Sardegna.',
    acceptAll: 'Accetta Tutti',
    decline: 'Rifiuta',
    advancedPrefs: 'Preferenze Avanzate',
    savePrefs: 'Salva Preferenze',
    alwaysActive: 'sempre attivi',
    necessary: 'Necessari',
    necessaryDesc: 'Cookie essenziali per il funzionamento del sito. Non possono essere disattivati.',
    analytics: 'Analitici',
    analyticsDesc: 'Ci aiutano a capire come usi il sito per migliorare la tua esperienza.',
    marketing: 'Marketing',
    marketingDesc: 'Utilizzati per mostrarti offerte e promozioni pertinenti.',
    preferences: 'Preferenze',
    preferencesDesc: 'Ricordano le tue scelte come lingua e zona di navigazione.',
  },

  // ============================================
  // AUTH - REGISTER
  // ============================================
  register: {
    title: 'Crea Account',
    subtitle: 'Inizia la tua avventura in mare',
    nameLabel: 'Nome Completo',
    namePlaceholder: 'Mario Rossi',
    emailLabel: 'Email',
    emailPlaceholder: 'tua@email.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    passwordHelper: 'Min 8 caratteri, maiuscola, minuscola, numero, carattere speciale',
    confirmPasswordLabel: 'Conferma Password',
    passwordMismatch: 'Le password non corrispondono',
    submitButton: 'Registrati',
    submittingButton: 'Registrazione...',
    hasAccount: 'Hai già un account? Accedi',
    // Role selection
    roleLabel: 'Tipo di account',
    roleGuest: 'Turista',
    roleGuestDesc: 'Prenota barche e servizi',
    roleVendor: 'Proprietario',
    roleVendorDesc: 'Metti in noleggio la tua barca',
    roleAgency: 'Agenzia',
    roleAgencyDesc: 'Rivendi barche e servizi delle aziende',
    roleCompany: 'Azienda',
    roleCompanyDesc: 'Gestisci una flotta di barche o servizi',
    roleServiceProvider: 'Fornitore Servizi',
    roleServiceProviderDesc: 'Offri servizi a barche e clienti',
    roleServiceProviderDisabled: 'Solo su invito',
    roleExcursion: 'Operatore Escursioni',
    roleExcursionDesc: 'Snorkeling, tour, trekking — solo escursioni',
    providesExcursionsLabel: 'Offro anche escursioni guidate',
    providesExcursionsHelp: 'Spunta se la tua azienda fa sia charter che escursioni: avrai accesso a entrambe le dashboard.',
    companyTypeTitle: 'Cosa fa la tua azienda?',
    companyTypeSubtitle: 'Spunta tutti i servizi che offri (puoi selezionarne più di uno)',
    serviceTypeTitle: 'Cosa offri?',
    serviceTypeSubtitle: 'Spunta tutti i servizi che offri (puoi selezionarne più di uno)',
    art49Title: 'Sei un privato: noleggio occasionale (art. 49-bis)',
    art49Intro: 'Come privato senza P.IVA puoi locare o noleggiare la tua imbarcazione in forma occasionale. Punti salienti:',
    art49P1: 'Massimo 42 giorni all’anno complessivi (locazione, escursioni ed esperienze).',
    art49P2: 'Regime fiscale agevolato: imposta sostitutiva del 20% sui proventi (a richiesta).',
    art49P3: 'Non costituisce esercizio di attività commerciale.',
    art49P4: 'Oltre la soglia serve la P.IVA: dovrai registrarti come Azienda.',
    art49Disclaimer: 'Riferimento: art. 49-bis Codice della Nautica da Diporto (D.Lgs 171/2005). Informazione indicativa, non consulenza fiscale.',
    vatLookupCta: 'Cerca dati da P.IVA',
    vatSearching: 'Cerco…',
    vatAutofilled: 'Dati auto-compilati — verifica e correggi se serve',
    vatEnterFirst: 'Inserisci prima la P.IVA',
    vatInvalid: 'P.IVA non valida',
    vatError: 'Errore nel recupero',
    vatNetworkError: 'Errore di rete',
    vatLookupHint: 'Inserisci la P.IVA e premi “Cerca” per pre-compilare ragione sociale, PEC e indirizzo (poi puoi modificarli).',
    companyTypeCharter: 'Charter / Noleggio barche',
    companyTypeCharterDesc: 'Gestisci una flotta di barche a noleggio',
    companyTypeExcursion: 'Solo escursioni',
    companyTypeExcursionDesc: 'Snorkeling, tour guidati, trekking, degustazioni — niente noleggio',
    companyTypeMixed: 'Charter + escursioni',
    companyTypeMixedDesc: 'Offri entrambe: avrai accesso alle due dashboard nella stessa area partner',
    vendorSectionTitle: 'Informazioni Proprietario',
    vendorPhoneLabel: 'Telefono',
    vendorPhonePlaceholder: '+39 333...',
    companySectionTitle: 'Dati Azienda',
    companyNameLabel: 'Ragione Sociale',
    companyNamePlaceholder: 'Nome Azienda S.r.l.',
    companyVatLabel: 'Partita IVA',
    companyVatPlaceholder: 'IT12345678901',
    companyPecLabel: 'PEC',
    companySdiLabel: 'Codice SDI',
    serviceProviderSectionTitle: 'Informazioni Fornitore',
    spSectionTitle: 'Informazioni Fornitore',
    spLicenseLabel: 'Numero Licenza',
    spLicensePlaceholder: 'Es. ABC-12345',
    spServiceAreaLabel: 'Area di servizio',
    spServiceAreaPlaceholder: 'es. Alghero, Sassari...',
    spFleetSizeLabel: 'Numero veicoli',
    passwordStrengthWeak: 'Debole',
    passwordStrengthFair: 'Discreta',
    passwordStrengthGood: 'Buona',
    passwordStrengthStrong: 'Forte',
    pendingApprovalInfo: 'Questo tipo di account richiede approvazione da parte del team.',
    pendingApprovalTitle: 'Registrazione Inviata',
    pendingApprovalMessage: 'Il tuo account è stato creato con successo. Il nostro team verificherà i tuoi dati e approverà il tuo profilo.',
    pendingApprovalStep1: '1. Account creato con successo',
    pendingApprovalStep2: '2. In attesa di verifica dal team',
    pendingApprovalStep3: '3. Riceverai una notifica via email',
    backToHome: 'Torna alla home',
  },

  // ============================================
  // MAINTENANCE PAGE
  // ============================================
  maintenance: {
    title: 'Sito in Manutenzione',
    message: 'Stiamo aggiornando il sito per offrirti un\'esperienza migliore. Torneremo online tra poco.',
    footer: 'InsulaCharter - Noleggio Barche in Sardegna',
  },

  // ============================================
  // LANDING PAGE (Pre-launch)
  // ============================================
  landing: {
    title: 'InsulaCharter',
    subtitle: 'Stiamo lavorando per te',
    message1: 'Il nostro nuovo sito è in fase di sviluppo.',
    message2: 'Presto potrai scoprire le migliori barche a noleggio in Sardegna.',
    needInfo: 'Hai bisogno di informazioni?',
    devAccess: 'Accesso sviluppatore',
    devLoginTitle: 'Accesso Sviluppatore',
    devLoginMessage: 'Inserisci la password per accedere al sito',
    wrongPassword: 'Password errata',
    copyright: '© 2026 InsulaCharter - Noleggio Barche in Sardegna',
  },

  // ============================================
  // TOAST MESSAGES
  // ============================================
  toast: {
    bookingCreated: 'Prenotazione creata con successo!',
    bookingCancelled: 'Prenotazione cancellata con successo!',
    bookingError: 'Errore nella creazione della prenotazione: ',
    boatCreated: 'Barca aggiunta con successo!',
    boatUpdated: 'Barca modificata con successo!',
    boatDeleted: 'Barca eliminata con successo!',
    maxPhotos: 'Puoi aggiungere massimo 10 foto',
    nameMinLength: 'Il nome deve avere almeno 3 caratteri',
    descriptionMinLength: 'La descrizione deve avere almeno 10 caratteri',
    serviceExists: 'Esiste già un servizio con questo nome',
  },

  // ============================================
  // CONFIRM DIALOGS
  // ============================================
  confirm: {
    cancelBooking: 'Vuoi cancellare la prenotazione?',
    deleteBoat: 'Vuoi davvero rimuovere questa barca dalla flotta InsulaCharter?',
    deleteServiceUsed: 'Questo servizio è utilizzato in {count} barche. Vuoi eliminarlo comunque?',
    deleteService: 'Vuoi eliminare questo servizio?',
  },

  // ============================================
  // LANGUAGE SELECTOR
  // ============================================
  language: {
    select: 'Lingua',
    it: 'Italiano',
    en: 'Inglese',
    de: 'Tedesco',
  },

  // ============================================
  // CALENDAR
  // ============================================
  calendar: {
    available: 'Disponibile',
    booked: 'Prenotata',
    pending: 'In attesa',
    blocked: 'Non disponibile',
    yourSelection: 'La tua selezione',
    selectDates: 'Seleziona le date',
    pickupDate: 'Ritiro',
    returnDate: 'Riconsegna',
    days: 'giorni',
    day: 'giorno',
    clearSelection: 'Cancella selezione',
    confirmDates: 'Conferma date',
    availability: 'Disponibilità',
    selectPickup: 'Seleziona la data di ritiro',
    selectReturn: 'Seleziona la data di riconsegna',
    // Booking detail modal
    bookingDetails: 'Dettagli Prenotazione',
    boat: 'Barca',
    client: 'Cliente',
    period: 'Periodo',
    passengers: 'passeggeri',
    total: 'Totale',
    basePrice: 'Noleggio',
    insuranceFee: 'Assicurazione',
    extras: 'Extra',
    specialRequests: 'Richieste speciali',
    createdAt: 'Creata il',
    unavailable: 'Non disponibile',
    paymentMethod: 'Metodo di Pagamento',
  },

  // ============================================
  // ICAL SYNC
  // ============================================
  ical: {
    title: 'Sincronizzazione iCal',
    titleWithBoat: 'Sincronizzazione iCal — {boatName}',
    exportUrl: 'URL di Esportazione',
    exportHint: 'Usa questo URL per importare il calendario su altre piattaforme (Airbnb, Booking.com, MMK Booking Manager, ecc.)',
    importedFeeds: 'Feed Importati',
    addFeed: 'Aggiungi Feed',
    feedUrlPlaceholder: 'URL del feed iCal',
    feedLabelPlaceholder: 'Etichetta (opzionale)',
    cancel: 'Annulla',
    adding: 'Aggiunta...',
    add: 'Aggiungi',
    noFeeds: 'Nessun feed importato',
    events: 'eventi',
    error: 'Errore',
    lastSync: 'Ultimo sync',
    confirmDelete: 'Eliminare questo feed iCal?',
    syncNow: 'Sincronizza ora',
    openFeed: 'Apri feed',
    deleteFeed: 'Elimina feed',
    sourceAirbnb: 'Airbnb',
    sourceBooking: 'Booking.com',
    sourceGoogle: 'Google Calendar',
    sourceMmk: 'MMK Booking Manager',
    sourceOther: 'Altro',
    guideTitle: 'Come collegare il tuo calendario esterno',
    guideStep1: '1. Copia l\'URL di esportazione qui sopra e incollalo nella piattaforma esterna (MMK, Airbnb, ecc.) come "calendario esterno" o "iCal feed"',
    guideStep2: '2. Nella piattaforma esterna, copia l\'URL del calendario della tua imbarcazione e incollalo qui sotto cliccando "Aggiungi Feed"',
    guideStep3: '3. La sincronizzazione avviene automaticamente ogni 15 minuti. Puoi forzarla con il bottone "Sincronizza ora"',
    boatsTitle: 'Imbarcazioni a noleggio',
    excursionsTitle: 'Escursioni & esperienze',
    excursionsHint: 'Pubblica le partenze delle tue escursioni/esperienze su calendari esterni (solo esportazione).',
    excursionsEmpty: 'Nessuna escursione o esperienza',
    copyExportUrl: 'Copia',
    manageFeeds: 'Gestisci feed',
  },

  // ============================================
  // BOOKING (Prenotazioni)
  // ============================================
  booking: {
    bookingSuspensionToggled: 'Stato sospensione prenotazioni aggiornato',
    confirmed: 'Confermata',
    pending: 'In attesa',
    cancelled: 'Cancellata',
    completed: 'Completata',
    refunded: 'Rimborsata',
    awaitingPayment: 'Da pagare',
    pendingLateBooking: 'In attesa di conferma',
    payNow: 'Paga ora',
    startingPayment: 'Avvio…',
    paymentStartFailed: 'Impossibile avviare il pagamento. Riprova.',
    networkErrorRetry: 'Errore di rete. Riprova.',
    modify: 'Modifica',
    cancel: 'Cancella',
    receipt: 'Ricevuta',
    paid: 'Pagato',
    notPaid: 'Da pagare',
    partiallyPaid: 'Parziale',
    depositPaid: 'Caparra versata',
    depositRefunded: 'Caparra rimborsata',
    paymentFailed: 'Fallito',
    departurePoint: 'Punto di partenza',
    departurePointRequired: 'Seleziona un punto di partenza',
    departureFrom: 'Partenza da',
  },

  // ============================================
  // CANCELLATION REQUEST (cliente-driven)
  // ============================================
  cancellation: {
    reasonBadWeather: 'Meteo avverso',
    reasonBadWeatherHint: 'Mare grosso, allerta ufficiale, condizioni non sicure',
    reasonHealth: 'Motivi di salute',
    reasonHealthHint: 'Malattia o infortunio del titolare prenotazione',
    reasonEmergency: 'Emergenza',
    reasonEmergencyHint: 'Imprevisto familiare o lavorativo grave',
    reasonForceMajeure: 'Causa di forza maggiore',
    reasonForceMajeureHint: 'Eventi non controllabili (es. blocchi, lutti)',
    reasonOther: 'Altro motivo',
    reasonOtherHint: 'Specifica il motivo nella descrizione',
    requestSentTitle: 'Richiesta di cancellazione inviata',
    requestSentDesc: 'Il vendor sta valutando la tua richiesta. Riceverai una risposta via email.',
    reasonLabel: 'Motivo:',
    rejectedTitle: 'Richiesta non approvata',
    rejectedDefaultDesc: 'Il vendor ha rifiutato la richiesta di cancellazione.',
    newRequest: 'Inviare una nuova richiesta',
    approvedTitle: 'Cancellazione approvata',
    approvedDesc: 'Il rimborso, se previsto, verrà elaborato secondo il metodo di pagamento.',
    requestCta: 'Richiedi cancellazione',
    formTitle: 'Richiesta cancellazione per giusta causa',
    formSubtitle: 'Seleziona il motivo. Il vendor valuterà la richiesta e potrà approvare o rifiutare.',
    description: 'Descrizione',
    descriptionPlaceholderOther: 'Spiega il motivo della richiesta (obbligatorio per "Altro")',
    descriptionPlaceholderDefault: 'Aggiungi dettagli utili al vendor (facoltativo)',
    minChars: 'Minimo 10 caratteri',
    cancel: 'Annulla',
    sending: 'Invio…',
    sendRequest: 'Invia richiesta',
    sendFailed: 'Invio fallito',
    unknownError: 'Errore sconosciuto',
  },

  // ============================================
  // REVIEW FORM
  // ============================================
  review: {
    selectRating: 'Seleziona una valutazione generale.',
    writeComment: 'Scrivi un commento.',
    submitError: 'Errore durante l\'invio della recensione.',
    overallRating: 'Valutazione generale *',
    titleLabel: 'Titolo (opzionale)',
    titlePlaceholder: 'Riassumi la tua esperienza',
    commentLabel: 'Commento *',
    commentPlaceholder: 'Racconta la tua esperienza...',
    detailedRatings: 'Valutazioni dettagliate (opzionali)',
    boatCondition: 'Condizione barca',
    itinerary: 'Itinerario',
    valueForMoney: 'Qualità/prezzo',
    communication: 'Comunicazione',
    sending: 'Invio...',
    submit: 'Invia recensione',
  },

  // ============================================
  // AMBASSADOR (banner + codici invito)
  // ============================================
  ambassador: {
    requestSent: 'Richiesta inviata',
    genericError: 'Errore',
    codeCopied: 'Codice copiato!',
    copyFailed: 'Impossibile copiare',
    linkCopied: 'Link copiato!',
    linkCopyFailed: 'Impossibile copiare il link',
    youAreAmbassador: 'Sei un Ambassador!',
    commissionPct: '{rate}% commissione',
    copyCode: 'Copia codice',
    copyInviteLink: 'Copia link invito',
    peopleReferred: 'persone portate',
    viaCode: ' · {used} via codice',
    withYourCode: ' con il tuo codice',
    generateLink: 'Genera link',
    pendingTitle: 'Richiesta ambassador in attesa',
    pendingDesc: 'Il team sta valutando la tua richiesta',
    rejectedDesc: 'La tua richiesta ambassador non è stata approvata.',
    becomeAmbassador: 'Diventa Ambassador',
    becomeAmbassadorDesc: 'Guadagna una commissione su ogni utente che porti alla piattaforma',
    sendingRequest: 'Invio in corso...',
    applyRequest: 'Richiedi di diventare Ambassador',
  },

  // ============================================
  // AMBASSADOR CODES MANAGER (multi-codice + referrals)
  // ============================================
  ambassadorCodes: {
    roleCustomer: 'Cliente',
    roleAgency: 'Agenzia',
    roleCollaborator: 'Collaboratore',
    roleVendor: 'Vendor',
    roleCompany: 'Azienda',
    roleAdmin: 'Admin',
    roleServiceProvider: 'Fornitore',
    roleHost: 'Host',
    codeActivated: 'Codice attivato',
    codeDeactivated: 'Codice disattivato',
    codeCreated: 'Codice {code} creato',
    createError: 'Errore nella creazione',
    loadingCodes: 'Caricamento codici...',
    myInviteCodes: 'I miei codici invito',
    newCode: 'Nuovo codice',
    deactivated: 'Disattivato',
    exhausted: 'Esaurito',
    uses: 'utilizzi',
    reactivate: 'Riattiva',
    deactivate: 'Disattiva',
    peopleBrought: 'Persone portate',
    noPeopleYet: 'Nessuna persona portata ancora.',
    tableName: 'Nome',
    tableType: 'Tipo',
    tableOrigin: 'Origine',
    tableDate: 'Data',
    manual: 'Manuale',
    viaCodeOrigin: 'Codice',
    newCodeModalTitle: 'Nuovo codice invito',
    newCodeModalSubtitle: 'Crea un codice per una campagna specifica',
    creating: 'Creazione...',
    createCode: 'Crea codice',
    label: 'Etichetta',
    optional: '(opzionale)',
    labelPlaceholder: 'Es. Campagna estate 2026',
    labelHint: 'Solo per la tua organizzazione — non visibile pubblicamente.',
    maxUses: 'Utilizzi massimi',
    maxUsesPlaceholder: 'Illimitato se vuoto',
    maxUsesHint: 'Quante volte il codice può essere usato prima di esaurirsi.',
    commissionNote: 'La commissione verrà ereditata dal tuo codice principale. Solo l\'amministratore può modificare la percentuale.',
  },

  // ============================================
  // PROFILE
  // ============================================
  profile: {
    // Page header
    myProfile: 'Il Mio Profilo',
    manageYourAccount: 'Gestisci i tuoi dati personali, documenti e preferenze di pagamento',

    // Sections
    personalData: 'Dati Personali',
    address: 'Indirizzo di Residenza',
    phoneNumber: 'Numero di Telefono',
    documents: 'Documenti di Identità',
    profilePhoto: 'Foto Profilo',

    // Personal data fields
    firstName: 'Nome',
    firstNamePlaceholder: 'Inserisci il tuo nome',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Inserisci il tuo cognome',
    dateOfBirth: 'Data di Nascita',
    nationality: 'Nazionalità',
    nationalityPlaceholder: 'Seleziona la tua nazionalità',
    fiscalCode: 'Codice Fiscale',
    fiscalCodePlaceholder: 'es: RSSMRA80A01H501U',
    fiscalCodeHelper: 'Opzionale - Solo per cittadini italiani',

    // Address fields
    street: 'Via/Indirizzo',
    streetPlaceholder: 'Via Roma, 123',
    city: 'Città',
    cityPlaceholder: 'es: Olbia',
    postalCode: 'CAP',
    postalCodePlaceholder: 'es: 07026',
    province: 'Provincia/Stato',
    provincePlaceholder: 'es: SS',
    country: 'Paese',
    countryPlaceholder: 'Seleziona il paese',

    // Phone fields
    mobilePhone: 'Telefono Cellulare',
    phoneHelper: 'Inserisci solo numeri, senza spazi o trattini',

    // Document fields
    documentType: 'Tipo Documento',
    selectDocumentType: 'Seleziona tipo documento...',
    identityCard: 'Carta d\'Identità',
    passport: 'Passaporto',
    drivingLicense: 'Patente di Guida',
    boatLicense: 'Patente Nautica',
    documentNumber: 'Numero Documento',
    documentNumberPlaceholder: 'es: AB1234567',
    documentExpiry: 'Data di Scadenza',
    frontImage: 'Immagine Fronte',
    backImage: 'Immagine Retro (opzionale)',
    clickToUpload: 'Clicca per caricare',
    addDocument: 'Aggiungi Documento',
    uploadDocument: 'Carica Documento',
    noDocuments: 'Nessun documento caricato',
    expiresOn: 'Scade il',
    verified: 'Verificato',
    pending: 'In attesa di verifica',
    confirmDeleteDocument: 'Vuoi eliminare questo documento?',
    requiredFields: 'Compila tutti i campi obbligatori',
    documentTooLarge: 'Il file è troppo grande. Massimo 10MB.',

    // Avatar
    uploadPhoto: 'Carica Foto',
    deletePhoto: 'Rimuovi',
    confirmDeleteAvatar: 'Vuoi rimuovere la foto profilo?',
    cropImage: 'Ritaglia Immagine',
    zoom: 'Zoom',
    rotate: 'Ruota',
    invalidImageType: 'Tipo file non valido. Usa PNG, JPG o PDF.',
    imageTooLarge: 'L\'immagine è troppo grande. Massimo 5MB.',

    // Email verification
    emailVerification: 'Verifica Email',
    emailVerified: 'Email Verificata',
    emailNotVerified: 'Email non verificata',
    verify: 'Verifica',
    clickToVerify: 'Clicca per verificare',
    resendVerification: 'Reinvia email di verifica',
    emailVerificationDescription: 'Verifica la tua email per sbloccare tutte le funzionalità del tuo account.',
    sendVerificationEmail: 'Invia Email di Verifica',
    verificationEmailSent: 'Email di verifica inviata! Controlla la tua casella di posta.',

    // User profile page
    loginToViewProfile: 'Effettua il login per visualizzare il tuo profilo.',
    myBookings: 'Prenotazioni',
    noBookings: 'Nessuna prenotazione',
    unknownBoat: 'Barca sconosciuta',
    guest: 'Ospite',
    memberSince: 'Membro da',
    bookingDetails: 'Dettagli Prenotazione',
    embarkationPoint: 'Punto di Imbarco',
    length: 'Lunghezza',
    maxCapacity: 'Max Capacità',
    bookingStatus: 'Stato Prenotazione',
    totalPaid: 'Totale Pagato',
    contactSkipper: 'Contatta Skipper',

    downloadReceipt: 'Scarica Ricevuta',

    // Success/Error messages
    updateSuccess: 'Profilo aggiornato con successo!',

    // Profile save (customer form)
    profileUpdated: 'Profilo aggiornato',
    saveError: 'Errore nel salvataggio',
    saving: 'Salvataggio…',
    saveProfile: 'Salva profilo',

    // Sezioni tab
    documentsTitle: 'Documenti',
    documentsSubtitle: 'Carica documento di identità e patente nautica',
    paymentMethodsSubtitle: 'Carte e metodi salvati',
    savedBoats: 'Le barche che hai salvato',
    ambassadorTab: 'Ambassador',
    ambassadorProgram: 'Programma Ambassador',
    ambassadorProgramDesc: 'Invita amici e guadagna commissioni sui noleggi',

    // Stats hero
    upcoming: 'In arrivo',
    total: 'Totali',
    nextDeparture: 'Prossima partenza',
    today: 'Oggi',
    tomorrow: 'Domani',
    inDays: 'Fra {n} giorni',
    bookingDetailsCta: 'Dettagli prenotazione',

    // Bookings list
    bookingSentSuccess: 'Prenotazione inviata con successo',
    bookingSentSuccessDesc: 'Riceverai una conferma via email appena il proprietario approverà la richiesta.',
    noBookingsYet: 'Nessuna prenotazione ancora',
    noBookingsDesc: 'Cerca una barca e prenota la tua prima esperienza in mare.',
    searchBoat: 'Cerca una barca',
    boatsSection: 'Barche',
    experiencesSection: 'Esperienze',
    experienceFallback: 'Esperienza',
    awaitingOperator: 'In attesa di conferma dell\'operatore',
    reviewed: 'Recensito',
    leaveReview: 'Lascia recensione',
    reviewSubmittedPending: 'Recensione inviata, in attesa di approvazione.',
    leaveReviewModalTitle: 'Lascia una recensione',
    leaveReviewModalSubtitle: 'La tua opinione aiuta gli altri viaggiatori',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    bookingCountOne: '{count} prenotazione',
    bookingCountOther: '{count} prenotazioni',
    notSet: 'Non impostato',
    exampleCityPlaceholder: 'Es: Olbia',
    exampleVatPlaceholder: 'Es: 01692360918',
  },

  // ============================================
  // FAVORITES
  // ============================================
  favorites: {
    title: 'Preferiti',
    empty: 'Nessun preferito salvato',
    emptyHint: 'Tocca il cuore sulle barche per salvarle qui.',
    remove: 'Rimuovi dai preferiti',
    added: 'Aggiunto ai preferiti',
    removed: 'Rimosso dai preferiti',
  },

  // ============================================
  // PAYMENTS
  // ============================================
  payments: {
    paymentMethods: 'Metodi di Pagamento',
    addMethod: 'Aggiungi Metodo',
    noMethods: 'Nessun metodo di pagamento salvato',
    addFirstMethod: 'Aggiungi il tuo primo metodo di pagamento',
    selectType: 'Seleziona tipo di pagamento',
    creditCard: 'Carta di Credito',
    bankTransfer: 'Bonifico Bancario',
    cash: 'Contanti',
    default: 'Predefinito',
    setAsDefault: 'Imposta come predefinito',
    confirmDelete: 'Vuoi eliminare questo metodo di pagamento?',

    // Credit Card
    cardNumber: 'Numero Carta',
    cardHolder: 'Intestatario Carta',
    expiryDate: 'Data di Scadenza',
    expires: 'Scade',
    cardSecurityNote: 'Per la tua sicurezza, non memorizziamo il numero completo della carta né il CVV.',

    // PayPal
    paypalEmail: 'Email PayPal',

    // IBAN
    accountHolder: 'Intestatario Conto',
    bankName: 'Nome Banca',

    // Common
    label: 'Etichetta',
    labelPlaceholder: 'es: Carta personale, Conto aziendale',
    optional: 'Opzionale',
  },

  // ============================================
  // EQUIPMENT (Dotazioni di Bordo)
  // ============================================
  equipment: {
    gps: { label: 'GPS Chartplotter', description: 'Sistema di navigazione GPS con cartografia marina' },
    vhf: { label: 'Radio VHF', description: 'Radio marina per comunicazioni di emergenza' },
    anchor: { label: 'Ancora con Catena', description: 'Ancora completa di catena e cima' },
    lifejackets: { label: 'Giubbotti Salvagente', description: 'Giubbotti di salvataggio per tutti i passeggeri' },
    bimini: { label: 'Tendalino Bimini', description: 'Tendalino parasole per protezione dal sole' },
    shower: { label: 'Doccia di Poppa', description: 'Doccia con acqua dolce a poppa' },
    cooler: { label: 'Frigo Portatile', description: 'Frigorifero portatile per bevande e cibo' },
    bluetooth: { label: 'Stereo Bluetooth', description: 'Impianto audio con connessione Bluetooth' },
    ladder: { label: 'Scaletta Bagno', description: 'Scaletta retrattile per facile accesso al mare' },
    cushions: { label: 'Cuscini Prendisole', description: 'Cuscini imbottiti per relax al sole' },
  },

  // ============================================
  // EXTRAS (Servizi Extra)
  // ============================================
  extras: {
    skipper: { label: 'Skipper Professionista', description: 'Capitano esperto per la navigazione' },
    hostess: { label: 'Hostess di Bordo', description: 'Assistenza e servizio a bordo' },
    fuel: { label: 'Pieno Carburante', description: 'Serbatoio pieno incluso nel prezzo' },
    snorkeling: { label: 'Kit Snorkeling', description: 'Maschera, boccaglio e pinne' },
    sup: { label: 'Stand Up Paddle', description: 'Tavola SUP con pagaia' },
    towable: { label: 'Ciambella Trainabile', description: 'Gonfiabile trainabile per divertimento' },
  },

  // ============================================
  // EXCURSION OPERATOR DASHBOARD
  // ============================================
  excursion: {
    dashboard: 'Pannello Escursioni',
    dashboardTitle: 'Dashboard Escursioni',
    dashboardTitleCompany: 'Dashboard Operatore',
    dashboardSubtitle: 'Gestisci catalogo, slot e prenotazioni',
    menuMain: 'Principale',
    menuFleet: 'Catalogo',
    menuOperations: 'Operazioni',
    menuFinance: 'Finanza',
    menuSettings: 'Impostazioni',
    fleet: 'Catalogo escursioni',
    calendar: 'Calendario',
    availability: 'Disponibilità',
    pricing: 'Prezzi',
    extras: 'Extra & Add‑on',
    bookings: 'Prenotazioni',
    requests: 'Richieste speciali',
    customRequests: 'Richieste',
    clients: 'Clienti',
    reviews: 'Recensioni',
    coupons: 'Coupons',
    team: 'Team',
    earnings: 'Guadagni',
    earningsByChannel: 'Guadagni per canale',
    reports: 'Report',
    notifications: 'Notifiche',
    profile: 'Profilo',
    settings: 'Impostazioni',
    guide: 'Guida operatore',
    roleCompany: 'Azienda',
    roleVendor: 'Operatore',
  },
  partner: {
    menuServices: 'Servizi',
    locazione: 'Locazione',
    escursioni: 'Escursioni',
    esperienze: 'Esperienze',
    disponibilita: 'Disponibilità',
    calendarioPartenze: 'Calendario partenze',
  },

  // ============================================
  // EXCURSION FLOW — release pubblica (modale, magic-link, catalogo V2)
  // ============================================
  customRequests: {
    title: 'Preventivi',
    subtitle: 'Richieste di prezzo su misura dai clienti',
    refresh: 'Aggiorna',
    filterActionable: 'Da lavorare',
    filterAll: 'Tutte',
    empty: 'Nessuna richiesta di preventivo.',
    deletedExcursion: 'Esperienza rimossa',
    status: {
      PENDING: 'Nuova',
      VENDOR_PROPOSED: 'Proposta inviata',
      CUSTOMER_COUNTER: 'Controproposta cliente',
      ACCEPTED: 'Accettata',
      REJECTED: 'Rifiutata',
      EXPIRED: 'Scaduta',
      CONVERTED: 'Prenotata',
    },
    drawerTitle: 'Dettaglio richiesta',
    noActivity: 'Nessuna attività ancora.',
    you: 'Tu',
    customer: 'Cliente',
    validUntil: 'Valida fino al',
    slotStart: 'Inizio',
    slotEnd: 'Fine',
    sendProposal: 'Invia proposta',
    proposalSent: 'Proposta inviata al cliente.',
    priceInvalid: 'Inserisci un prezzo valido.',
    pricePlaceholder: 'Prezzo €',
    notesPlaceholder: 'Note per il cliente (facoltative)',
    messagePlaceholder: 'Scrivi un messaggio…',
    reject: 'Rifiuta richiesta',
    rejected: 'Richiesta rifiutata.',
    rejectReasonPlaceholder: 'Motivo (facoltativo)',
    confirmReject: 'Conferma rifiuto',
  },
  myRequests: {
    title: 'Le mie richieste',
    subtitle: 'Preventivi richiesti e proposte ricevute',
    back: 'Torna alle richieste',
    empty: 'Non hai ancora richieste di preventivo.',
    deletedExcursion: 'Esperienza rimossa',
    status: {
      PENDING: 'In attesa di risposta',
      VENDOR_PROPOSED: 'Proposta ricevuta',
      CUSTOMER_COUNTER: 'Controproposta inviata',
      ACCEPTED: 'Accettata',
      REJECTED: 'Rifiutata',
      EXPIRED: 'Scaduta',
      CONVERTED: 'Prenotata',
    },
  },
  excursionFlow: {
    // Catalog hero V2
    catalogKicker: 'Sardegna · esperienze',
    catalogTitlePart1: 'Quello che',
    catalogTitleAccent: 'l’isola',
    catalogTitlePart2: 'non racconta nelle guide.',
    catalogSubtitle: 'Itinerari guidati e attività curate da operatori locali — dal trekking ai tour in barca, dallo snorkeling alle degustazioni.',
    catalogCounterLabel: 'Esperienze attive',
    catalogFilterAll: 'Tutte',
    catalogEmptyTitle: 'Stiamo curando le prossime esperienze.',
    catalogEmptyBody: 'Le escursioni per la prossima stagione saranno pubblicate a breve. Nel frattempo puoi esplorare le barche disponibili a noleggio.',
    catalogEmptyCta: 'Vedi le barche',
    catalogEmptyFilterTitle: 'Nessuna escursione in questa categoria.',
    catalogEmptyFilterBody: 'Prova a rimuovere il filtro per vedere tutte le esperienze.',
    catalogEmptyFilterCta: 'Vedi tutte',

    // CTA card escursione "Scopri"
    cardDiscover: 'Scopri',
    cardFeaturedBadge: 'In evidenza',
    cardOnRequest: 'Su richiesta',
    cardFrom: 'Da',
    cardPerPerson: 'a persona',
    cardPerGroup: 'a gruppo',
    cardMaxPeople: 'max',

    // Special request CTA + modale
    specialRequestCta: 'Fai una richiesta speciale',
    modalTitle: 'Richiesta speciale',
    modalTypeLabel: 'Tipo di richiesta',
    typeTimeCustomLabel: 'Orario custom',
    typeTimeCustomDesc: 'Stesso tour, orario di partenza diverso',
    typeGroupCustomLabel: 'Gruppo non standard',
    typeGroupCustomDesc: 'Numero persone fuori dalla capacità standard',
    typePrivateLabel: 'Tour privato',
    typePrivateDesc: 'Solo voi, niente altri partecipanti',
    typeFullyCustomLabel: 'Esperienza su misura',
    typeFullyCustomDesc: 'Itinerario/durata/contenuto diversi',
    fieldDateStart: 'Data preferita',
    fieldDateEnd: 'Data fine (se più giorni)',
    fieldPeople: 'Persone',
    fieldMessage: 'Messaggio per l\'operatore',
    fieldMessagePlaceholder: 'Es. Vorremmo partire alle 16:00 invece dell\'orario standard, siamo una famiglia con 2 bambini di 8 e 10 anni…',
    fieldContactsHeading: 'I tuoi contatti',
    fieldName: 'Nome e cognome',
    fieldEmail: 'Email',
    fieldPhone: 'Telefono (opzionale)',
    btnCancel: 'Annulla',
    btnSendRequest: 'Invia richiesta',
    successTitle: 'Richiesta inviata',
    successBody: 'Il nostro operatore riceverà una notifica e ti risponderà via email a {email} con una proposta personalizzata. Controlla anche la cartella spam.',
    successCta: 'Ho capito',
    disclaimer: 'Ti risponderemo entro qualche ora via email. La richiesta non comporta nessun impegno: potrai accettare o rifiutare la proposta finale dell\'operatore.',

    // Magic-link page cliente
    magicHeroKicker: 'Richiesta speciale',
    magicHeroGreeting: 'Ciao {name}, ecco la proposta del nostro operatore.',
    magicProposalLabel: 'Proposta del vendor',
    magicProposalTotal: 'totale',
    magicProposalWhen: 'Data/ora',
    magicProposalValidUntil: 'Valida fino al',
    magicProposalNotes: 'Dettagli',
    magicAcceptCta: 'Accetta e paga',
    magicRejectCta: 'Rifiuta',
    magicCounterCta: 'Controproponi',
    magicCounterTitle: 'Controproposta',
    magicCounterSubmit: 'Invia',
    magicAcceptConfirm: 'Confermi di voler accettare la proposta? Verrai reindirizzato al pagamento.',
    magicRejectPrompt: 'Motivo (opzionale, visibile al vendor):',
    magicRejectConfirm: 'Confermi rifiuto?',
    magicLinkExpiredTitle: 'Link non valido',
    magicLinkExpiredBody: 'Richiesta non trovata o link scaduto',
    magicMyRequest: 'La tua richiesta',
    magicConversation: 'Conversazione',
    magicMsgPlaceholder: 'Scrivi al vendor…',
    magicValidUntilFooter: 'Link valido fino al {date}.',
    magicCreateAccount: 'Crea un account',
    magicCreateAccountSuffix: 'per gestire tutte le tue richieste.',
    magicStatusAccepted: 'Proposta accettata. Procedi al pagamento per confermare.',
    magicStatusConverted: 'Pagamento completato. La tua escursione è confermata.',
    magicStatusRejected: 'Proposta rifiutata.',
    magicStatusExpired: 'Richiesta scaduta.',
  },

  // ============================================
  // VENDOR DASHBOARD
  // ============================================
  vendor: {
    earningsByChannel: 'Guadagni per canale',
    // Dashboard
    dashboard: 'Dashboard',
    dashboardTitle: 'Dashboard Vendor',
    dashboardTitleCompany: 'Dashboard Azienda',
    dashboardSubtitle: 'Gestisci le tue barche e prenotazioni',

    // Sidebar menu groups
    menuMain: 'Principale',
    menuFleet: 'Flotta',
    menuOperations: 'Operazioni',
    menuFinance: 'Finanza',
    menuSettings: 'Impostazioni',
    // Sidebar menu items
    fleet: 'Imbarcazioni',
    pricing: 'Prezzi',
    bulk: 'Operazioni Bulk',
    suspensions: 'Sospensioni',
    extras: 'Servizi Extra',
    bookings: 'Prenotazioni',
    customRequests: 'Richieste',
    clients: 'Clienti',
    reviews: 'Recensioni',
    coupons: 'Coupons',
    team: 'Team',
    network: 'Rete & Collaboratori',
    earnings: 'Guadagni',
    reports: 'Report',
    analytics: 'Analytics',
    notifications: 'Notifiche',
    profile: 'Profilo',
    settings: 'Impostazioni',
    guide: 'Guida',
    roleVendor: 'Armatore',
    roleCompany: 'Azienda',

    // Navigation (legacy)
    myBoats: 'Le mie barche',
    myBookings: 'Prenotazioni ricevute',
    myEarnings: 'Guadagni',
    myClients: 'I miei clienti',
    myExtras: 'Servizi Extra',
    myProfile: 'Profilo Vendor',
    calendar: 'Calendario',

    // Tabs
    tabDashboard: 'Dashboard',
    tabMyBoats: 'Le mie barche',
    tabCalendar: 'Calendario',
    tabBookings: 'Prenotazioni',
    tabEarnings: 'Guadagni',
    tabClients: 'Clienti',
    tabProfile: 'Profilo',
    tabCompanyProfile: 'Dati aziendali',

    // Stats
    activeBoats: 'Barche attive',
    totalBookings: 'Prenotazioni',
    totalRevenue: 'Ricavi Totali',
    totalPayout: 'Payout Netto',
    platformFees: 'Commissioni Piattaforma',
    bookingCount: 'Prenotazioni',
    netEarnings: 'Guadagno netto',
    pendingPayout: 'In attesa di payout',
    paidOut: 'Già pagato',
    occupancyRate: 'Tasso Occupazione',
    revenuePerBoat: 'Ricavo Medio/Barca',
    loadingStats: 'Caricamento statistiche...',
    commissionUpdated: 'Commissione aggiornata',

    // Boat List
    loadingBoats: 'Caricamento barche...',
    noBoats: 'Nessuna barca',
    noBoatsHint: 'Aggiungi la tua prima barca dalla dashboard admin',
    boatsCount: 'barche',
    boatActive: 'Attiva',
    boatInactive: 'Inattiva',
    approvalApproved: 'Approvata',
    approvalPending: 'In revisione',
    approvalRejected: 'Rifiutata',
    approvalNotes: 'Note:',
    loadBoatsError: 'Errore nel caricamento barche',

    // Calendar
    calendarTitle: 'Calendario Prenotazioni',
    calendarSubtitle: 'Visualizza e gestisci le prenotazioni delle tue barche',
    loadingCalendar: 'Caricamento calendario...',
    noBoatsCalendar: 'Aggiungi una barca per vedere il calendario',
    allBoats: 'Tutte le barche',
    blockDates: 'Blocca date',
    blockDatesTitle: 'Blocca date',
    blockingFor: 'Blocco per',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    blockReason: 'Motivo (opzionale)',
    blockReasonPlaceholder: 'Es: manutenzione, uso personale...',
    blockWarning: 'Le date bloccate impediranno nuove prenotazioni per il periodo selezionato',
    confirmBlock: 'Conferma blocco',
    datesBlocked: 'Date bloccate con successo',
    datesUnblocked: 'Date sbloccate',
    blockError: 'Errore nel bloccare le date',
    unblockError: 'Errore nello sbloccare le date',
    selectBoatFirst: 'Seleziona prima una barca',
    selectDatesFirst: 'Seleziona le date da bloccare',
    blockedPeriods: 'Periodi bloccati',
    unblock: 'Sblocca',
    fleetOverview: 'Panoramica flotta',
    confirmed: 'confermate',
    pendingLabel: 'in attesa',
    blocked: 'bloccate',
    noBookingsYet: 'Nessuna prenotazione',
    calendarLoadError: 'Errore nel caricamento dati calendario',

    // Bookings
    loadingBookings: 'Caricamento prenotazioni...',
    allStatuses: 'Tutti gli stati',
    pendingBookings: 'In attesa',
    confirmedRevenue: 'Fatturato confermato',
    bookingsTitle: 'Prenotazioni',
    bookingsSubtitle: 'Gestisci le prenotazioni',
    noBookingsFound: 'Nessuna prenotazione trovata',
    allPaymentStatuses: 'Tutti i pagamenti',
    paymentPending: 'Da pagare',
    paymentPaid: 'Pagato',
    paymentPartial: 'Parziale',
    paymentRefunded: 'Rimborsato',
    calendarView: 'Calendario',
    listView: 'Lista',
    searchGuest: 'Cerca cliente...',
    downloadReceipt: 'Scarica ricevuta',
    reversibleBookings: 'Prenotazioni Annullabili',
    reversibleBookingsSubtitle: 'Puoi ripristinare lo stato precedente',
    boatsOverview: 'Riepilogo Barche',
    cancelWithReason: 'Cancella con motivo',
    cancelConfirmMessage: 'Sei sicuro di voler cancellare questa prenotazione?',
    cancelReasonPlaceholder: 'Motivo della cancellazione (opzionale)',
    bookingDetail: 'Dettaglio Prenotazione',
    guestInfo: 'Informazioni Cliente',
    boatInfo: 'Informazioni Barca',
    rentalDetails: 'Dettagli Noleggio',
    experienceDetails: 'Dettagli Esperienza',
    priceSummary: 'Riepilogo Prezzo',
    basePrice: 'Prezzo base',
    insuranceFee: 'Assicurazione',
    specialRequests: 'Richieste Speciali',
    cancellationReason: 'Motivo Cancellazione',
    reverse: 'Ripristina',
    undo: 'Annulla',
    statusPending: 'In attesa',
    statusConfirmed: 'Confermata',
    statusCompleted: 'Completata',
    statusCancelled: 'Cancellata',
    noBookings: 'Nessuna prenotazione',
    boatFallback: 'Barca',
    guestFallback: 'Ospite',
    nights: 'notti',
    guests: 'ospiti',
    netPayout: 'Netto:',
    loadBookingsError: 'Errore nel caricamento prenotazioni',

    // Earnings
    loadingEarnings: 'Caricamento guadagni...',
    platformCommission: 'Commissione piattaforma',
    earningsDetail: 'Dettaglio guadagni',
    headerBoat: 'Barca',
    headerDates: 'Date',
    headerTotal: 'Totale',
    headerCommission: 'Commissione',
    headerNet: 'Netto',
    headerPayout: 'Payout',
    payoutPaid: 'Pagato',
    payoutPending: 'In attesa',

    // Client Management
    searchClient: 'Cerca cliente...',
    noClients: 'Nessun cliente',
    noClientsHint: 'I clienti appariranno qui dopo la prima prenotazione',
    bookingsLabel: 'Prenotazioni',
    spentLabel: 'Speso',
    loadClientsError: 'Errore nel caricamento clienti',

    // Vendor Profile
    profileTitle: 'Profilo Vendor',
    profileUpdated: 'Profilo aggiornato con successo',
    firstName: 'Nome',
    firstNamePlaceholder: 'Mario',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Rossi',
    phone: 'Telefono',
    phonePlaceholder: '+39 333 1234567',
    bio: 'Bio',
    bioPlaceholder: 'Presentati ai tuoi clienti...',
    vendorBio: 'Bio / Descrizione',
    vendorPhone: 'Telefono',
    payoutData: 'Dati Payout',
    iban: 'IBAN',
    ibanPlaceholder: 'IT60X0542811101000000123456',
    payoutIban: 'IBAN Payout',
    accountHolder: 'Intestatario conto',
    accountHolderPlaceholder: 'Mario Rossi',
    payoutHolder: 'Intestatario',
    saveProfile: 'Salva profilo',
    loadProfileError: 'Errore nel caricamento profilo',
    saveProfileError: 'Errore nel salvataggio',

    // Company Profile
    companyData: 'Dati Aziendali',
    companyName: 'Ragione sociale',
    companyNamePlaceholder: 'Sardinia Charter S.r.l.',
    vatNumber: 'Partita IVA',
    companyVat: 'Partita IVA',
    vatPlaceholder: 'IT12345678901',
    sdiCode: 'Codice SDI',
    companySdi: 'Codice SDI',
    sdiPlaceholder: 'M5UXCR1',
    pec: 'PEC',
    companyPec: 'PEC',
    pecPlaceholder: 'azienda@pec.it',
    companyPhone: 'Telefono aziendale',
    companyPhonePlaceholder: '+39 070 1234567',
    officeAddress: 'Indirizzo sede',
    street: 'Via',
    streetPlaceholder: 'Via Roma 1',
    city: 'Città',
    cityPlaceholder: 'Olbia',
    province: 'Provincia',
    provincePlaceholder: 'SS',
    postalCode: 'CAP',
    postalCodePlaceholder: '07026',
    presentation: 'Presentazione',
    companyBioPlaceholder: 'Descrivi la tua azienda ai clienti...',
    saveCompanyProfile: 'Salva profilo aziendale',
    companyProfileUpdated: 'Profilo aziendale aggiornato',
    perDay: '/giorno',
    saving: 'Salvataggio...',

    // Booking as guest
    bookingOptions: 'Opzioni Prenotazione',
    canBookAsGuest: 'Voglio anche prenotare barche',
    canBookAsGuestDesc: 'Attiva questa opzione per poter prenotare barche di altri vendor come cliente.',
    alsoClient: 'Anche cliente',

    // Extras Management
    tabExtras: 'Servizi Extra',
    extrasTitle: 'I miei Servizi Extra',
    extrasSubtitle: 'Gestisci i servizi aggiuntivi per le tue barche',
    addExtra: 'Nuovo Extra',
    editExtra: 'Modifica Extra',
    noExtras: 'Nessun servizio extra',
    noExtrasHint: 'Crea il tuo primo servizio extra per offrirlo ai clienti',
    extraKey: 'Chiave (ID univoco)',
    extraKeyPlaceholder: 'es: skipper_service',
    extraLabel: 'Nome Servizio',
    extraLabelPlaceholder: 'es: Servizio Skipper',
    extraDescription: 'Descrizione',
    extraDescPlaceholder: 'Descrivi il servizio extra...',
    extraPrice: 'Prezzo Default (€)',
    extraPriceType: 'Tipo Prezzo',
    pricePerStay: 'Per noleggio',
    pricePerDay: 'Per giorno',
    pricePerPerson: 'Per persona',
    pricePerPersonDay: 'Per persona/giorno',
    extraStatusApproved: 'Approvato',
    extraStatusPending: 'In revisione',
    extraStatusRejected: 'Rifiutato',
    approvalWarning: 'La modifica di un extra approvato lo reinvia per approvazione admin.',
    editResetsApproval: 'La modifica di un extra approvato lo rimanda in revisione',
    extraCreated: 'Servizio extra creato. In attesa di approvazione.',
    extraUpdated: 'Servizio extra aggiornato',
    extraDeleted: 'Servizio extra eliminato',
    extraSaveError: 'Errore nel salvare il servizio extra',
    extraDeleteError: 'Errore nell\'eliminare il servizio extra',
    rejectionNotes: 'Note di rifiuto',
    loadExtrasError: 'Errore nel caricamento servizi extra',
  },

  // ============================================
  // COMPANY DASHBOARD
  // ============================================
  company: {
    // Menu groups
    menuMain: 'Principale',
    menuFleet: 'Gestione Flotta',
    menuOperations: 'Operazioni',
    menuFinance: 'Finanza',
    menuSettings: 'Impostazioni',

    // Menu items
    overview: 'Panoramica',
    fleet: 'Flotta',
    calendar: 'Calendario',
    bookings: 'Prenotazioni',
    clients: 'Clienti',
    coupons: 'Coupons',
    team: 'Team',
    earnings: 'Guadagni',
    reports: 'Report',
    companyProfile: 'Profilo Aziendale',
    settings: 'Impostazioni',
    companyAccount: 'Account Aziendale',

    // Overview
    welcomeBack: 'Bentornato, {name}',
    overviewSubtitle: 'Panoramica delle attività della tua azienda',
    recentBookings: 'Ultime Prenotazioni',
    viewAll: 'Vedi tutte',
    quickActions: 'Azioni Rapide',
    quickFleet: 'Gestisci Flotta',
    quickFleetDesc: 'Aggiungi e gestisci le tue barche',
    quickCalendar: 'Calendario',
    quickCalendarDesc: 'Visualizza disponibilità e prenotazioni',
    quickReports: 'Report',
    quickReportsDesc: 'Analizza guadagni e genera export',

    // Team
    teamSubtitle: 'Gestisci il tuo team operativo',
    teamComingSoon: 'Gestione Team in arrivo',
    teamComingSoonDesc: 'Presto potrai aggiungere skipper, operatori e manager al tuo team aziendale.',
    plannedRoles: 'Ruoli Previsti',
    roleSkipper: 'Skipper',
    roleSkipperDesc: 'Capitani per le tue barche',
    roleOperator: 'Operatore',
    roleOperatorDesc: 'Gestione prenotazioni e clienti',
    roleManager: 'Manager',
    roleManagerDesc: 'Supervisione flotta e operazioni',

    // Reports
    reportsSubtitle: 'Analisi dettagliata dei guadagni',
    dateFrom: 'Da',
    dateTo: 'A',
    clearFilters: 'Resetta',
    totalRevenue: 'Ricavi Totali',
    totalCommission: 'Commissioni',
    totalNet: 'Netto',
    noReportData: 'Nessun dato per il periodo selezionato',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    nights: 'Notti',

    // Export
    exportCSV: 'Esporta CSV',
    exportPDF: 'Esporta PDF',
    comingSoon: 'Prossimamente',
  },

  // Promo overlay (public)
  promo: {
    close: 'Chiudi',
    discover: 'Scopri',
    bookNow: 'Prenota Ora',
    prev: 'Precedente',
    next: 'Successivo',
  },

  // Service Provider System
  sp: {
    dashboardTitle: 'I Miei Servizi',
    dashboardSubtitle: 'Gestisci le tue richieste di servizio',
    role: 'Fornitore Servizi',
    tabStats: 'Statistiche',
    tabRequests: 'Richieste',
    tabProfile: 'Profilo',
    statsPending: 'In Attesa',
    statsAccepted: 'Accettati',
    statsCompleted: 'Completati',
    statsRevenue: 'Ricavi Mese',
    statusPENDING: 'In Attesa',
    statusBROADCAST: 'In Broadcast',
    statusACCEPTED: 'Accettato',
    statusCOMPLETED: 'Completato',
    statusREJECTED: 'Rifiutato',
    statusCANCELLED: 'Cancellato',
    statusEXPIRED: 'Scaduto',
    noRequests: 'Nessuna richiesta di servizio',
    requestDetail: 'Dettaglio Richiesta',
    boat: 'Barca',
    guest: 'Ospite',
    guestPhone: 'Telefono Ospite',
    passengers: 'Passeggeri',
    pickupDate: 'Data Andata',
    returnDate: 'Data Ritorno',
    pickup: 'Luogo Ritiro',
    dropoff: 'Destinazione',
    specialRequests: 'Richieste Speciali',
    rejectionReason: 'Motivo Rifiuto',
    rejectionReasonPlaceholder: 'Inserisci il motivo del rifiuto...',
    notes: 'Note Interne',
    notesPlaceholder: 'Aggiungi note...',
    saveNotes: 'Salva Note',
    accept: 'Accetta',
    reject: 'Rifiuta',
    complete: 'Completa',
    confirmReject: 'Conferma Rifiuto',
    profileBasic: 'Informazioni Base',
    name: 'Nome',
    phone: 'Telefono',
    license: 'Numero Licenza',
    licensePlaceholder: 'Es. OT/12345',
    bio: 'Descrizione',
    fleet: 'Flotta Veicoli',
    fleetSize: 'Numero Veicoli',
    maxPassengers: 'Max Passeggeri',
    vehicleTypes: 'Tipi di Veicolo',
    vehiclePlaceholder: 'Es. Sedan, Minivan 8 posti',
    serviceArea: 'Zone Servite',
    serviceAreaPlaceholder: 'Es. Olbia, Porto Cervo',
    operatingHours: 'Orari Operativi',
    saveProfile: 'Salva Profilo',
    // Calendar tab
    tabCalendar: 'Calendario',
    calendarTitle: 'Calendario Appuntamenti',
    calendarRequests: 'richieste',
    // Extras tab
    tabExtras: 'Servizi',
    myExtras: 'I miei Servizi',
    createExtra: 'Nuovo Servizio',
    editExtra: 'Modifica Servizio',
    extrasEmpty: 'Nessun servizio creato',
    extraPendingInfo: 'I nuovi servizi vengono inviati per approvazione. Modificare un servizio approvato lo riporta in revisione.',
    extraEditWarning: 'Modificando un servizio approvato, verrà riportato in stato "In revisione" per una nuova approvazione.',
    extraDeleteConfirm: 'Sei sicuro di voler eliminare',
    extraApproved: 'Approvato',
    extraPendingReview: 'In revisione',
    extraRejected: 'Rifiutato',
    extraKeyLabel: 'Chiave (ID univoco)',
    extraNameLabel: 'Nome Servizio',
    extraDescLabel: 'Descrizione',
    extraPriceLabel: 'Prezzo Default (€)',
    extraPriceTypeLabel: 'Tipo Prezzo',
    extraSave: 'Salva Modifiche',
    extraCategory: 'Categoria',
    extraCategoryMobility: 'Mobilità (noleggi & transfer)',
    extraCategoryOther: 'Altro servizio',
    extraPorts: 'Porti operativi *',
    extraPortsHint: 'Seleziona i porti dove offri questo servizio. I clienti vedranno il servizio solo per le barche ormeggiate in questi porti.',
    extraPortsEmpty: 'Nessun porto disponibile',
    extraPortsRequired: 'Seleziona almeno un porto operativo',
    extraPortsSelectedOne: 'porto selezionato',
    extraPortsSelectedMany: 'porti selezionati',
    extraOperatingAt: 'Operativo a',
    pricingMode: 'Modalità prezzo',
    pricingModeFixed: 'Prezzo fisso',
    pricingModeQuote: 'Su richiesta (preventivo)',
    pricingModeQuoteHint: 'Il cliente richiederà un preventivo invece di vedere il prezzo. Lo riceverai nella tua dashboard come richiesta da gestire.',
    priceNotApplicable: 'Non applicabile',
    // Marketplace broadcast (Phase 1)
    broadcastTitle: 'Marketplace in diretta',
    broadcastHint: 'Il primo che accetta si aggiudica il servizio. Sii veloce!',
    claimNow: 'Accetta veloce',
    claimSuccess: 'Richiesta accettata!',
    claimLost: 'Già preso da un altro fornitore',
    // Empty state — new SP with no linked ServiceProvider profile yet
    noProfileYet: 'Non hai ancora un profilo fornitore attivo',
    noProfileHint: 'Attendi che l\'admin ti assegni un servizio, oppure iscriviti a una tipologia dal tab "Le mie offerte" per iniziare a ricevere richieste dal marketplace.',
    pendingApprovalTitle: 'Account in Attesa di Approvazione',
    pendingApprovalMessage: 'Il tuo account è in fase di verifica. Riceverai una notifica quando sarà approvato.',
    // Generic service keys
    serviceType: 'Tipo Servizio',
    bikeRental: 'Noleggio Bici',
    ebikeRental: 'Noleggio E-Bike',
    scooterRental: 'Noleggio Scooter',
    monopattinoRental: 'Noleggio Monopattino',
    transferPorto: 'Transfer Porto',
    allServices: 'Tutti i Servizi',
    filterByService: 'Filtra per servizio',
    requestFrom: 'Richiesta da',
    quantity: 'Quantità',
    serviceDate: 'Data Servizio',
    providerNotes: 'Note Fornitore',
    // Error / toast messages
    errLoadRequests: 'Impossibile caricare le richieste di servizio',
    errLoadStats: 'Impossibile caricare le statistiche',
    errLoadCalendar: 'Impossibile caricare il calendario',
    errLoadProfile: 'Impossibile caricare il profilo',
    errSaveProfile: 'Impossibile salvare il profilo',
    errAcceptRequest: 'Impossibile accettare la richiesta',
    errRejectRequest: 'Impossibile rifiutare la richiesta',
    errCompleteRequest: 'Impossibile completare la richiesta',
    errSaveNotes: 'Impossibile salvare le note',
    profileSaved: 'Profilo salvato con successo',
    notesSaved: 'Note salvate',
    capacityCheck: 'Capacity automatica',
    capacityCheckEnabled: 'Blocco automatico attivo',
    capacityCheckDisabled: 'Blocco automatico disattivato',
    capacityCheckHintEnabled: 'Quando attivo, il sistema rifiuta automaticamente nuove richieste se per quella data hai già raggiunto il numero massimo configurato in "capacità massima".',
    capacityCheckHintDisabled: 'Riceverai tutte le richieste anche oltre la capacità configurata e gestirai manualmente eventuali conflitti.',
    capacityCheckSaved: 'Impostazione capacity aggiornata',
    capacityExhausted: 'Il fornitore non ha più disponibilità per la data richiesta',
    // Payment collection mode
    paymentMode: 'Modalità di incasso',
    paymentModeFull: 'Incassiamo tutto noi',
    paymentModeFullDesc: 'La piattaforma incassa l\'intero importo della prenotazione e ti accredita il netto tramite bonifico.',
    paymentModeCommissionOnly: 'Incassiamo solo la commission',
    paymentModeCommissionDesc: 'La piattaforma trattiene solo la sua percentuale. Il saldo viene pagato direttamente a te dal cliente al check-in (cash o POS).',
    paymentModeFullHint: 'Modalità standard: tutto passa dalla piattaforma e ricevi il netto via bonifico.',
    paymentModeCommissionHint: 'In questa modalità i clienti pagheranno il saldo direttamente a te al porto. La piattaforma trattiene solo la sua percentuale.',
    spIban: 'IBAN per accrediti',
    spIbanHolder: 'Intestatario conto',
    paymentModeSaved: 'Modalità di incasso salvata',
    // SP catalog (offers tab)
    tabOffers: 'Le mie offerte',
    offersTitle: 'Catalogo Offerte',
    offersDesc: 'Iscriviti alle tipologie di servizio create dall\'admin con le tue tariffe',
    offersAdd: 'Aggiungi offerta',
    offersEdit: 'Modifica offerta',
    offersDelete: 'Elimina offerta',
    offersSelectTemplate: 'Seleziona tipologia',
    offersCustomPrice: 'Prezzo personalizzato',
    offersCapacity: 'Capacità',
    offersNotes: 'Note',
    offersPorts: 'Porti operativi',
    offersEmpty: 'Nessuna offerta attiva. Aggiungine una per iniziare.',
    offersNoTemplates: 'Nessuna tipologia disponibile. L\'admin deve crearne almeno una.',
    offersCreated: 'Offerta creata',
    offersUpdated: 'Offerta aggiornata',
    offersDeleted: 'Offerta eliminata',
  },

  // ============================================
  // SERVICES SUBDOMAIN
  // ============================================
  servicesLogin: {
    title: 'Insula Services',
    subtitle: 'Area Fornitori Servizi',
    sectionLabel: 'Accesso Fornitori',
    submit: 'Accedi',
    submitting: 'Accesso in corso...',
    accessDenied: "Quest'area è riservata ai fornitori di servizi.",
    copyright: 'Tutti i diritti riservati.',
  },
  servicesCatalog: {
    title: 'Servizi Disponibili',
    subtitle: 'I nostri partner di servizio sul territorio',
    noProviders: 'Nessun fornitore disponibile al momento',
    becomeProvider: 'Diventa Fornitore',
    requestService: 'Richiedi un Servizio',
    serviceArea: 'Zone Servite',
    vehicleTypes: 'Veicoli',
    maxPassengers: 'Max Passeggeri',
    howItWorks: 'Come Funziona',
    howItWorksDesc: 'Prenota un\'escursione in barca e aggiungi il servizio transfer. Un fornitore locale si occuperà del tuo trasporto.',
  },
  servicesNavbar: {
    dashboard: 'Dashboard',
    catalog: 'Catalogo Servizi',
    login: 'Accedi',
    logout: 'Esci',
  },

  // ============================================
  // SP SELF-REGISTRATION WIZARD
  // ============================================
  spReg: {
    title: 'Diventa Fornitore di Servizi',
    subtitle: 'Registrati alla piattaforma Insula Services in pochi passaggi.',
    becomeProvider: 'Diventa Fornitore',
    step1Title: 'Account',
    step2Title: 'Dati aziendali',
    step3Title: 'Categorie e porti',
    step4Title: 'Riepilogo',
    next: 'Avanti',
    previous: 'Indietro',
    submit: 'Invia richiesta',
    fieldName: 'Nome e cognome',
    fieldEmail: 'Email',
    fieldPassword: 'Password',
    fieldPasswordConfirm: 'Conferma password',
    fieldPhonePrefix: 'Prefisso',
    fieldPhoneNumber: 'Telefono',
    fieldCompanyName: 'Ragione sociale',
    fieldVAT: 'Partita IVA',
    fieldTaxCode: 'Codice fiscale',
    fieldAddress: 'Indirizzo',
    fieldCity: 'Città',
    fieldProvince: 'Provincia',
    fieldPostalCode: 'CAP',
    selectCategories: 'Categorie di servizi offerti',
    selectPorts: 'Porti operativi',
    summaryTitle: 'Controlla i dati',
    summaryHint: 'Verifica che tutto sia corretto prima di inviare la richiesta di registrazione.',
    successTitle: 'Richiesta inviata',
    successMessage: 'La tua registrazione è stata ricevuta. Un amministratore la esaminerà a breve e riceverai una notifica via email.',
    errors: {
      required: 'Questo campo è obbligatorio',
      emailInvalid: 'Email non valida',
      passwordWeak: 'La password deve contenere almeno 8 caratteri',
      passwordMismatch: 'Le password non coincidono',
      selectCategory: 'Seleziona almeno una categoria',
      selectPort: 'Seleziona almeno un porto',
      emailExists: 'Questa email è già registrata',
      generic: 'Si è verificato un errore. Riprova.',
    },
  },

  boatWizard: {
    useType: {
      label: "Destinazione d'uso",
      locazione: { label: 'Locazione', desc: 'Noleggio in autonomia (bareboat): compare nel catalogo noleggio' },
      excursionOnly: { label: 'Solo esperienze', desc: 'Usata solo per esperienze/escursioni, fuori dal catalogo noleggio' },
    },
    pricingMode: {
      label: 'Modalita prezzo',
      fixed: { label: 'Prezzo fisso', desc: 'Prezzi visibili: il cliente vede i prezzi e prenota direttamente' },
      quoteOnRequest: { label: 'Prezzo su richiesta', desc: 'Il cliente invia una richiesta di preventivo; tu rispondi con un prezzo personalizzato' },
      priceFieldsHidden: 'I campi prezzo sono nascosti perche la barca e impostata su "Prezzo su richiesta".',
    },
  },

};

export default it;
